// Global variables for delivery slot management
let slots_modal = null;
let availableDatesForModal = [];
let selectedDate = null;
let selectedType = null;
let resEndIntHandle = null;
// Context (postcode/suburb/store) the currently rendered slot list was fetched
// for, and an epoch counter that invalidates in-flight fetches and pending
// restore timers whenever the user changes postcode / delivery type / suburb.
// Without this, slots rendered for a previous postcode could be reserved
// against a new postcode (wrong store, wrong zone).
let slotsContext = null;
let slotsFetchEpoch = 0;

const postcodeModalInput = document.getElementById("spost-code-modal");
if (postcodeModalInput) {
  postcodeModalInput.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      document.getElementById("submit-delivery-postode")?.click();
    }
  });
}

const cartTimer = document.querySelector(".delivery-countdown");
// Shipping error messages
const noExpressDeliveryError =
  '<b>Unfortunately Express Delivery isn\'t available in your area.</b> Please select "Delivery" to check if scheduled deliveries are available in your area.';
const noDeliveryError =
  '<b>Unfortunately we do not deliver to your area.</b> To register your interest please <b><a href="https://harrisfarmsupport.zendesk.com/hc/en-us/categories/200270127-Online" target="_new">contact us</a></b>.';

// Helper function to get cookie (already defined in cart.js, but including here for standalone use)
function getCookie(name) {
  const cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    const cookiePair = cookieArray[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function removeCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

// Helper functions to show/hide delivery drawer loading overlay
function showDeliveryOverlay() {
  const overlay = document.querySelector('.delivery-overlay.updating-cart-overlay');
  if (overlay) {
    overlay.classList.add('show');
    
    // Animate the simple progress bar (not the stacked overlay one)
    const progressFill = overlay.querySelector('.progress-bar-fill');
    if (progressFill && !overlay.querySelector('.overlay-updates-stack')) {
      // Reset to 0 first
      progressFill.style.width = '0%';
      
      // Animate to 90% over time (indeterminate progress)
      setTimeout(() => {
        progressFill.style.width = '90%';
      }, 50);
    }
  }
}

function hideDeliveryOverlay() {
  const overlay = document.querySelector('.delivery-overlay.updating-cart-overlay');
  if (overlay) {
    overlay.classList.remove('show');
    
    // Reset simple progress bar
    const progressFill = overlay.querySelector('.progress-bar-fill');
    if (progressFill && !overlay.querySelector('.overlay-updates-stack')) {
      progressFill.style.width = '0%';
    }
  }
}

// Overlay update helpers for delivery drawer
function addDeliveryOverlayUpdate(id, text, state = 'loading') {
  const stack = document.querySelector('.delivery-overlay.updating-cart-overlay .overlay-updates-stack');
  if (!stack) return null;
  
  // Add progress bar if it doesn't exist
  if (!stack.querySelector('.overlay-progress-bar')) {
    const progressBar = document.createElement('div');
    progressBar.className = 'overlay-progress-bar';
    progressBar.innerHTML = '<div class="overlay-progress-bar-fill"></div>';
    stack.insertBefore(progressBar, stack.firstChild);
  }
  
  const item = document.createElement('div');
  item.className = `overlay-update-item ${state}`;
  item.id = `delivery-overlay-update-${id}`;
  
  if (state === 'loading') {
    item.innerHTML = `
      <div class="icon-tick-wrapper">
        <svg
          aria-hidden="true"
          focusable="false"
          class="spinner"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
      <div class="update-text">${text}</div>
    `;
  } else if (state === 'completed') {
    item.innerHTML = `
      <div class="icon-tick-wrapper">
        <svg class="icon-tick" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd" d="m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256z" fill="#4bae4f" fill-rule="evenodd"/>
          <path d="m206.7 373.1c-32.7-32.7-65.2-65.7-98-98.4-3.6-3.6-3.6-9.6 0-13.2l37.7-37.7c3.6-3.6 9.6-3.6 13.2 0l53.9 53.9 138.6-138.7c3.7-3.6 9.6-3.6 13.3 0l37.8 37.8c3.7 3.7 3.7 9.6 0 13.2l-183.3 183.1c-3.6 3.7-9.5 3.7-13.2 0z" fill="#fff"/>
        </svg>
      </div>
      <div class="update-text">${text}</div>
    `;
    } else {
    item.innerHTML = `
      <div class="icon-tick-wrapper">
        <svg class="icon-tick" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd" d="m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256z" fill="#cccccc" fill-rule="evenodd"/>
          <path d="m206.7 373.1c-32.7-32.7-65.2-65.7-98-98.4-3.6-3.6-3.6-9.6 0-13.2l37.7-37.7c3.6-3.6 9.6-3.6 13.2 0l53.9 53.9 138.6-138.7c3.7-3.6 9.6-3.6 13.3 0l37.8 37.8c3.7 3.7 3.7 9.6 0 13.2l-183.3 183.1c-3.6 3.7-9.5 3.7-13.2 0z" fill="#fff"/>
        </svg>
      </div>
      <div class="update-text">${text}</div>
    `;
  }
  
  stack.appendChild(item);
  updateDeliveryOverlayProgress();
  return item;
}

function updateDeliveryOverlayItemState(id, state, newText) {
  const item = document.getElementById(`delivery-overlay-update-${id}`);
  if (!item) return;
  
  item.className = `overlay-update-item ${state}`;
  
  if (state === 'completed') {
    item.innerHTML = `
      <div class="icon-tick-wrapper">
        <svg class="icon-tick" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd" d="m256 0c-141.2 0-256 114.8-256 256s114.8 256 256 256 256-114.8 256-256-114.8-256-256-256z" fill="#4bae4f" fill-rule="evenodd"/>
          <path d="m206.7 373.1c-32.7-32.7-65.2-65.7-98-98.4-3.6-3.6-3.6-9.6 0-13.2l37.7-37.7c3.6-3.6 9.6-3.6 13.2 0l53.9 53.9 138.6-138.7c3.7-3.6 9.6-3.6 13.3 0l37.8 37.8c3.7 3.7 3.7 9.6 0 13.2l-183.3 183.1c-3.6 3.7-9.5 3.7-13.2 0z" fill="#fff"/>
        </svg>
      </div>
      <div class="update-text">${newText || item.querySelector('.update-text').textContent}</div>
    `;
  } else if (state === 'loading') {
    item.innerHTML = `
      <div class="icon-tick-wrapper">
        <svg
          aria-hidden="true"
          focusable="false"
          class="spinner"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
      <div class="update-text">${newText || item.querySelector('.update-text').textContent}</div>
    `;
  }
  
  updateDeliveryOverlayProgress();
}

function updateDeliveryOverlayProgress() {
  const stack = document.querySelector('.delivery-overlay.updating-cart-overlay .overlay-updates-stack');
  if (!stack) return;
  
  const allItems = stack.querySelectorAll('.overlay-update-item');
  const completedItems = stack.querySelectorAll('.overlay-update-item.completed');
  const progressFill = stack.querySelector('.overlay-progress-bar-fill');
  
  if (allItems.length > 0 && progressFill) {
    const percentage = (completedItems.length / allItems.length) * 100;
    progressFill.style.width = `${percentage}%`;
  }
}

function clearDeliveryOverlayStack() {
  const stack = document.querySelector('.delivery-overlay.updating-cart-overlay .overlay-updates-stack');
  if (stack) stack.innerHTML = '';
}

// JSONP fetch helper for cross-domain requests
// Supports two calling patterns:
// 1. fetchJSONP(url, params) - new pattern with params object
// 2. fetchJSONP(url, callbackParamName) - old pattern where callbackParamName is "c"
function fetchJSONP(url, paramsOrCallbackParam = {}, method = 'GET', timeout = 10000) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    let callbackFunctionName = 'jsonp_callback_' + Math.round(100000 * Math.random());
    let fullUrl;
    let timeoutId;
    
    // Set up the callback function
    window[callbackFunctionName] = function(data) {
      if (timeoutId) clearTimeout(timeoutId);
      delete window[callbackFunctionName];
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      console.log('JSONP success:', data);
      resolve(data);
    };
    
    // Handle old calling pattern: fetchJSONP(url, "c") where "c" is the callback param name
    if (typeof paramsOrCallbackParam === 'string') {
      // URL already has all params, just add the callback parameter
      const callbackParamName = paramsOrCallbackParam;
      fullUrl = `${url}&${callbackParamName}=${callbackFunctionName}`;
      console.log('JSONP request URL (old pattern with callback param "' + callbackParamName + '"):', fullUrl);
    } else {
      // New pattern: fetchJSONP(url, { postcode: '2010' })
      const paramString = Object.keys(paramsOrCallbackParam)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsOrCallbackParam[key])}`)
        .join('&');
      
      fullUrl = `${url}${url.includes('?') ? '&' : '?'}${paramString}&callback=${callbackFunctionName}`;
      console.log('JSONP request URL:', fullUrl);
    }

    timeoutId = setTimeout(() => {
      delete window[callbackFunctionName];
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      console.error('JSONP request timeout after', timeout, 'ms');
      reject(new Error('JSONP request timeout'));
    }, timeout);
    
    script.src = fullUrl;
    
    script.onerror = () => {
      if (timeoutId) clearTimeout(timeoutId);
      delete window[callbackFunctionName];
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
      console.error('JSONP script load error for URL:', fullUrl);
      reject(new Error('JSONP request failed'));
    };
    
    document.body.appendChild(script);
  });
}

// DOM Utility Functions
const DOMHelpers = {
  // Hide multiple elements by ID
  hideElements: function(ids) {
    ids.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });
  },
  
  // Show multiple elements by ID with optional display type
  showElements: function(ids, displayType = "flex") {
    ids.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.style.display = displayType;
    });
  },
  
  // Set text content for element by ID
  setText: function(id, text) {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  },
  
  // Set value for element by ID
  setValue: function(id, value) {
    const el = document.getElementById(id);
    if (el) el.value = value;
  },
  
  // Enable/disable multiple elements by ID
  setDisabled: function(ids, disabled) {
    ids.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.disabled = disabled;
    });
  },
  
  // Get element value safely
  getValue: function(id, defaultValue = '') {
    const el = document.getElementById(id);
    return el ? el.value : defaultValue;
  }
};

// Invalidate the current slot context: any slot options still in the DOM no
// longer belong to what the user is selecting. Clears the rendered date/time
// options (so a stale slot can't be re-shown or reserved), resets the slot
// data global, bumps the fetch epoch (aborting in-flight fetch handling and
// pending restore timers) and disables the reserve button until fresh slots
// are rendered.
function invalidateSlotsContext() {
  slotsFetchEpoch++;
  slotsContext = null;
  slots_modal = null;
  const datePicker = document.getElementById("date-picker-select");
  if (datePicker) datePicker.innerHTML = "";
  const timeModal = document.getElementById("sdelivery-time-modal");
  if (timeModal) timeModal.innerHTML = '<option value="0">Select delivery time</option>';
  DOMHelpers.setDisabled(["delivery-type-submit"], true);
}

document.addEventListener('DOMContentLoaded', function () {
  let deliveryVariant;

  // Consolidated event delegation for all delivery drawer buttons
  document.addEventListener("click", function (e) {
    // Check which button was clicked
    let target = null;
    
    // Submit postcode button
    if (e.target.closest("#submit-delivery-postode")) {
      target = e.target.closest("#submit-delivery-postode");
      console.log('Submit postcode button clicked');
      e.preventDefault();
      
      const deliveryBtns = document.querySelectorAll("#delivery-type-select-btns button");
      deliveryBtns.forEach(btn => btn.classList.remove("delivery-type-select-btns-selected"));
      
      console.log('Calling showAvailableDeliveryButtons()');
      showAvailableDeliveryButtons();
      return;
    }
    
    // Delivery type selection buttons (general handler)
    if (e.target.closest("#delivery-type-select-btns button")) {
      target = e.target.closest("#delivery-type-select-btns button");
      e.preventDefault();
      console.log('Delivery type button clicked:', target.id);

      const errorModal = document.getElementById("delivery-error-modal");
      
      clearReservationExpiredNotice();

      const expressInfo = document.querySelector(".delivery-express-info");
      if (expressInfo) {
        expressInfo.style.display = "none";
      }

      const deliveryPreorder = getCookie("delivery_preorder");
      const preorderToken = document.getElementById("preorder-token");
      const preorderInput = document.getElementById("delivery-preorder-token-input");
      const preorderBox = document.getElementById("delivery-preorder-token-input-box");

      if (deliveryPreorder) {
        if (preorderToken) preorderToken.checked = true;
        if (preorderInput) {
          preorderInput.value = deliveryPreorder;
          preorderInput.dispatchEvent(new Event('change'));
        }
        if (preorderBox) preorderBox.style.display = "block";
      } else {
        if (preorderToken) preorderToken.checked = false;
        if (preorderInput) {
          preorderInput.value = "";
          preorderInput.dispatchEvent(new Event('change'));
        }
      }

      const preorderInvalid = document.getElementById("delivery-preorder-invalid");
      if (preorderInvalid) preorderInvalid.style.display = "none";
      if (errorModal) errorModal.style.display = "none";
    }
    
    // Standard Delivery button specific
    if (e.target.closest("#delivery-type-delivery")) {
      target = e.target.closest("#delivery-type-delivery");
      e.preventDefault();
      console.log('Delivery button clicked');
      
      const postcodeModal = document.getElementById("spost-code-modal");
      const postcode = DOMHelpers.getValue("spost-code-modal");

      if (postcodeModal) postcodeModal.focus();
      
      DOMHelpers.setText("delivery-type-submit", "Reserve Delivery");
      DOMHelpers.hideElements(["delivery-type-reserve", "cc-store-row"]);
      
      const deliveryTypeButtons = document.querySelectorAll("#delivery-type-select-btns button");
      deliveryTypeButtons.forEach(btn => btn.classList.remove("delivery-type-select-btns-selected"));
      target.classList.add("delivery-type-select-btns-selected");

    loadDeliverySlots(postcode);
      return;
    }
    
    // Click & Collect button specific
    if (e.target.closest("#delivery-type-click-collect")) {
      target = e.target.closest("#delivery-type-click-collect");
      e.preventDefault();
      console.log('Click & Collect button clicked');
      
      loadClickCollectStores();
      
      DOMHelpers.showElements(["delivery-type-reserve", "cc-store-row"]);
      DOMHelpers.setValue("cc-store", "");
      DOMHelpers.setText("delivery-type-submit", "Reserve Collection");
      
      DOMHelpers.hideElements([
        "delivery-postcode-modal", "delivery-suburb-modal", "delivery-day-modal",
        "delivery-type-modal", "clickcollect-info-modal", "delivery-time-modal",
        "delivery-preorder-token", "delivery-preorder-token-input-box"
      ]);
      
      const deliveryTypeButtons = document.querySelectorAll("#delivery-type-select-btns button");
      deliveryTypeButtons.forEach(btn => btn.classList.remove("delivery-type-select-btns-selected"));
      target.classList.add("delivery-type-select-btns-selected");
      
      removeCookie("delivery_preorder");
      return;
    }
    
    // Express delivery button specific
    if (e.target.closest("#delivery-type-express")) {
      target = e.target.closest("#delivery-type-express");
      e.preventDefault();
      console.log('Express delivery button clicked');
      
      const postcodeModal = document.getElementById("spost-code-modal");
      const postcode = DOMHelpers.getValue("spost-code-modal");

      if (postcodeModal) postcodeModal.focus();
      
      DOMHelpers.hideElements([
        "delivery-type-reserve", "cc-store-row", "delivery-error-modal",
        "delivery-preorder-token", "delivery-preorder-token-input-box"
      ]);
      
      DOMHelpers.setText("delivery-type-submit", "Reserve Delivery");
      
      const expressInfo = document.querySelector(".delivery-express-info");
      if (expressInfo) expressInfo.style.display = "flex";
      
      const deliveryTypeButtons = document.querySelectorAll("#delivery-type-select-btns button");
      deliveryTypeButtons.forEach(btn => btn.classList.remove("delivery-type-select-btns-selected"));
      target.classList.add("delivery-type-select-btns-selected");
      
      removeCookie("delivery_preorder");

      loadDeliverySlots(postcode);
      return;
    }
  });

  document
    .querySelectorAll(
      ".postcode-open, .delivery-details, .res-delivery-time, #seafood-change-date, #mealkit-change-date, #loosesalad-change-date, #shortdate-change-date, #instorebakery-change-date, #wholesale-change-date, #noliquorgf-change-date, #xmastree-change-date, #xmastree-non-ct-change-date, #voomcart-change-date, #voomcart-non-vc-change-date"
    )
    .forEach(function (element) {
      element.addEventListener("click", function (event) {
        theme.promptForDeliveryType();
        event.preventDefault();
      });
    });

  // Delivery type form submission
  const deliveryTypeForm = document.getElementById("delivery-type-form");
  if (deliveryTypeForm) {
    deliveryTypeForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      
      const clickCollect = document.getElementById("delivery-type-click-collect")?.classList.contains("delivery-type-select-btns-selected");
      const ccStore = document.getElementById("cc-store");
      const postcodeModal = document.getElementById("spost-code-modal");
      
      let postcode;
      if (clickCollect && ccStore) {
        const selectedOption = ccStore.options[ccStore.selectedIndex];
        postcode = selectedOption.dataset.zone_postcode;
      } else if (postcodeModal) {
        postcode = postcodeModal.value;
      }
      
      const expressDelivery = document.getElementById("delivery-type-express")?.classList.contains("delivery-type-select-btns-selected");
      let doCartUpdate = false;

      const datePicker = document.getElementById("date-picker-select");

      // Get the selected delivery slot ID
      const deliveryTimeModal = document.getElementById("sdelivery-time-modal");
      const uniqueWindow = deliveryTimeModal?.options[deliveryTimeModal.selectedIndex]?.dataset.slotId;

      // Delivery date for the reservation. The date <select> can be sitting on
      // its placeholder (a suburb change reloads the dates and resets it), so
      // never trust it blindly - fall back to the date encoded in the slot id
      // being reserved (e.g. "20260703-84-EX-284-1500-1600" -> 2026-07-03).
      let deliveryDate = datePicker ? datePicker.value : '';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(deliveryDate)) {
        const slotDate = (uniqueWindow || '').split('-')[0];
        deliveryDate = /^\d{8}$/.test(slotDate)
          ? `${slotDate.slice(0, 4)}-${slotDate.slice(4, 6)}-${slotDate.slice(6, 8)}`
          : '';
      }

      // Guard: never reserve a slot that wasn't rendered for the postcode
      // being submitted. Stale options can linger in the DOM (e.g. the user
      // changed postcode while an earlier fetch/restore was still completing)
      // and reserving one silently books the WRONG store/zone.
      const slotStoreForSubmit = getStoreFromUniqueWindow(uniqueWindow);
      const slotContextValid =
        slotsContext &&
        String(slotsContext.postcode) === String(postcode) &&
        (clickCollect || !slotStoreForSubmit || String(slotsContext.store) === slotStoreForSubmit);
      if (!slotContextValid) {
        console.error('⚠️ Stale delivery slot blocked at submit. Slot:', uniqueWindow,
          'context:', slotsContext, 'submitted postcode:', postcode, '- reloading slots.');
        showDeliveryError("Delivery times were out of date for your location. Please choose a delivery time again.");
        if (postcode) {
          loadDeliverySlots(postcode);
        }
        return;
      }

      // Keep checkout locked from reservation submission until cart.js confirms
      // that the delivery-fee line matches the newly selected delivery mode.
      window.__hfDeliveryReservationUpdating = true;
      if (typeof agileCart !== "undefined" && agileCart.disableCheckout) {
        agileCart.disableCheckout();
      }

      // Show stacked overlay
      clearDeliveryOverlayStack();
      addDeliveryOverlayUpdate('reserving', 'Reserving delivery slot...', 'loading');
      showDeliveryOverlay();

      try {
        // Reserve delivery slot
        const reservationParams = new URLSearchParams({
          action: "set",
          cart_id: getCookie("cart") || '',
          unique_window: uniqueWindow || '',
          express_delivery: expressDelivery
        });
        
        const data_reservation = await fetchJSONP(
          `${deliveryURL}reservations.php?${reservationParams.toString()}`,
          "c"
        );

            if (data_reservation.status === "SUCCESS") {
          const _data = JSON.parse(getCookie("postcode_data") || '{}');
                console.log("----- RESERVATION ------");
                console.log(uniqueWindow);

          // Check liquor availability for the selected delivery window.
          try {
            const response = await fetch(`https://apps.harrisfarm.com.au/delivery/liquor-allowed.php?delivery_unique_window=${encodeURIComponent(uniqueWindow)}`);
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const liquorData = await response.json();
            const liquorAllowed = liquorData.liquorAllowed;
            const currentTime = new Date()
              .toTimeString()
              .split(" ")[0]
              .replace(/:/g, "");
            const liquorDeliveryStart = liquorData.liquorStartTime;
            const liquorDeliveryEnd = liquorData.liquorEndTime;

            const hasLiquorCutoff = liquorDeliveryStart && liquorDeliveryEnd;
            const withinLiquorCutoff = !hasLiquorCutoff || (
              currentTime >= String(liquorDeliveryStart).replace(/:/g, "") &&
              currentTime <= String(liquorDeliveryEnd).replace(/:/g, "")
            );
            const liquorDeliveryAvailable = Boolean(liquorAllowed && withinLiquorCutoff);

            localStorage.setItem("liquorDeliveryAvailable", liquorDeliveryAvailable ? "true" : "false");
            if (liquorDeliveryAvailable && !window.customerAlcoholBlock && !(typeof hideAlcohol !== "undefined" && hideAlcohol === true)) {
              document.body.classList.remove("hide-alcohol");
            } else {
              document.body.classList.add("hide-alcohol");
            }
          } catch (error) {
            console.error("Error checking liquor availability:", error);
            localStorage.setItem("liquorDeliveryAvailable", "false");
            document.body.classList.add("hide-alcohol");
          }

          // Get postcode details
          const postcodeParams = new URLSearchParams({
                        postcode: postcode,
                        delivery_date: deliveryDate,
            express_delivery: expressDelivery
          });
          
          const data = await fetchJSONP(
            `${deliveryURL}postcodedetails.php?a=1&${postcodeParams.toString()}`,
            "c"
          );

          // Validate the postcodedetails response up-front. The old nested ifs
          // had no else branch, so an unusable response (e.g. when the request
          // carried a bad delivery_date) silently dead-ended with the loading
          // overlay stuck - even though the reservation itself had succeeded.
          const postcodeDetailsOk =
            data.status === "SUCCESS" &&
            data.response &&
            data.response[0] &&
            data.response[0] !== "EMPTY" &&
            data.response[0].postcode == postcode;

          if (postcodeDetailsOk) {
            data.response = data.response[0];

            // The reserved slot encodes the store it belongs to. If it does
            // not match the store postcodedetails just returned for this
            // postcode, the reservation is invalid (a stale slot slipped
            // through, or the API is inconsistent). Do NOT silently pick a
            // winner and flip storage back and forth - abort before writing
            // any state, surface it, and re-render fresh slots.
            const reservedSlotStore = getStoreFromUniqueWindow(uniqueWindow);
            const apiPickingStore = data.response.picking_store ? data.response.picking_store.toString() : null;
            if (!clickCollect && reservedSlotStore && apiPickingStore && reservedSlotStore !== apiPickingStore) {
              console.error(`⚠️ Reserved slot ${uniqueWindow} belongs to store ${reservedSlotStore} but postcodedetails says postcode ${postcode} is served by store ${apiPickingStore}. Aborting without changing state and reloading slots.`);
              window.__hfDeliveryReservationUpdating = false;
              if (typeof agileCart !== "undefined" && agileCart.fetchCart) agileCart.fetchCart();
              hideDeliveryOverlay();
              showDeliveryError("We couldn't confirm your delivery details for this postcode. Please choose a delivery time again.");
              loadDeliverySlots(postcode);
              return;
            }

              // Postcode ok - set postcode, picking_store and delivery details cookies
              setCookie("postcode", postcode, 365);
              // Suburb must come from the slot context actually reserved. The
              // postcode_data cookie holds the suburb the user picked for this
              // slot fetch; only trust it if it is for the postcode being
              // reserved, otherwise fall back to the fresh API row.
              const reservedSuburb =
                (_data.response && String(_data.response.postcode) === String(postcode))
                  ? _data.response.suburb
                  : (data.response.suburb || "");
              setCookie("suburb", reservedSuburb || "", 365);

              // Get current picking store from storage (NOT from cart items)
              const cookiePickingStore = getCookie("picking_store");
              const lsPickingStore = localStorage.getItem('currentPickingStore');
              const locationManagerStore = window.locationManager ? window.locationManager.currentLocation : null;
              const newPickingStore = data.response.picking_store ? data.response.picking_store.toString() : null;
              
              console.log('Delivery reservation - Checking picking store:');
              console.log('  Cookie:', cookiePickingStore);
              console.log('  LocalStorage:', lsPickingStore);
              console.log('  LocationManager:', locationManagerStore);
              console.log('  API New:', newPickingStore);
              
              // Use the most reliable STORAGE value (NOT cart items)
              // Priority: LocationManager > localStorage > cookie
              const currentPickingStore = locationManagerStore || lsPickingStore || cookiePickingStore;
              
              console.log('  → Current stored location:', currentPickingStore);
              console.log('  → New API location:', newPickingStore);
              
              // Check if picking store actually changed
              const storeHasChanged = newPickingStore && currentPickingStore !== newPickingStore;
              
              // Check if this is an initial reservation (no previous delivery set)
              const previousDeliveryExpiry = getCookie("delivery_expires_time");
              const hadPreviousDelivery = previousDeliveryExpiry && parseInt(previousDeliveryExpiry) > new Date().getTime();
              const isInitialReservation = !hadPreviousDelivery;
              
              if (storeHasChanged) {
                // Picking store change - need to update cart
                                    doCartUpdate = true;
                console.log('  STORE CHANGED:', currentPickingStore, '→', newPickingStore);
                console.log('  Cart will be updated with new location prices');
                
                // Show stacked overlay for major operation
                clearDeliveryOverlayStack();
                addDeliveryOverlayUpdate('delivery-updated', 'Delivery updated', 'completed');
                addDeliveryOverlayUpdate('checking-availability', 'Checking product availability...', 'pending');
                addDeliveryOverlayUpdate('syncing-storage', 'Syncing location settings...', 'pending');
              } else if (isInitialReservation) {
                // Initial reservation - need to add delivery fee to cart
                doCartUpdate = true;
                console.log('  INITIAL RESERVATION - Need to add delivery fee to cart');
                console.log('  Cart will be updated to add delivery product');
                
                // Show stacked overlay for cart update
                clearDeliveryOverlayStack();
                addDeliveryOverlayUpdate('delivery-updated', 'Delivery reserved', 'completed');
                addDeliveryOverlayUpdate('adding-delivery', 'Adding delivery fee to cart...', 'pending');
              } else {
                console.log('  SAME STORE - No cart update needed');
                console.log('  Only updating delivery time/date');
              }
              
              // ALWAYS sync all storage to newPickingStore to ensure 100% consistency
              if (newPickingStore) {
                console.log('  Syncing ALL storage to match API:', newPickingStore);
                
                // Update cookie
                setCookie("picking_store", newPickingStore, 365);
                console.log('   Cookie updated');
                
                // Update localStorage
                localStorage.setItem('currentPickingStore', newPickingStore);
                console.log('    LocalStorage updated');
                
                // Update LocationManager and dispatch location change event
                if (window.locationManager) {
                  window.locationManager.setLocation(newPickingStore);
                  console.log('   LocationManager updated and locationChanged event dispatched');
                } else {
                  console.warn('  LocationManager not available');
                }
                
                console.log('  All storage now synchronized to:', newPickingStore);
              }

              // Guard: the reserved slot itself encodes its store and IS
              // store-specific, so it is the ultimate source of truth. If what
              // storage now holds disagrees with the slot (e.g. postcodedetails
              // returned a different suburb's row, or a sync step rewrote the
              // value), re-sync everything to the slot's store.
              const slotStore = getStoreFromUniqueWindow(uniqueWindow);
              if (slotStore) {
                const syncedStore = getCookie("picking_store");
                if (syncedStore !== slotStore) {
                  console.error(`⚠️ picking_store mismatch after sync: storage says ${syncedStore} but reserved slot ${uniqueWindow} belongs to store ${slotStore}. Re-syncing to the slot's store.`);
                  syncPickingStoreStorage(slotStore);
                  doCartUpdate = true;
                }
              }
              
              const deliveringTo = document.getElementById("delivering-to");
              if (deliveringTo) {
                deliveringTo.style.display = "block";
                const link = deliveringTo.querySelector("a");
                if (link) link.innerHTML = getCookie("suburb");
              }

              // Set delivery details cookies
              const expiryTime = new Date().getTime() + data_reservation.response.seconds_remaining * 1000;
              console.log('Setting delivery_expires_time cookie:', expiryTime);
              console.log('  seconds_remaining:', data_reservation.response.seconds_remaining);
              console.log('  expires in minutes:', Math.round(data_reservation.response.seconds_remaining / 60));
              
              setCookie("delivery_expires_time", expiryTime, 365);
              setCookie("delivery_date", deliveryDate, 365);
              
              const deliveryTypeModal = document.getElementById("sdelivery-type-modal");
              if (deliveryTypeModal) {
                const selectedOption = deliveryTypeModal.options[deliveryTypeModal.selectedIndex];
                setCookie("delivery_type", selectedOption.value, 365);
                setCookie("delivery_type_long", selectedOption.text, 365);
              }
              
              if (clickCollect && ccStore) {
                const selectedCCOption = ccStore.options[ccStore.selectedIndex];
                setCookie("delivery_cc_store", ccStore.value, 365);
                setCookie("delivery_cc_name", selectedCCOption.text, 365);
                if (postcodeModal) {
                  setCookie("postcode_cc_display", postcodeModal.value, 365);
                }
                // Several modules (body class, cart totals, service fee, minimum
                // order) read this flag but nothing was ever writing it.
                localStorage.setItem("clickCollectSelected", "true");
                document.body.classList.add("click-collect-active");
              } else {
                removeCookie("delivery_cc_store");
                localStorage.removeItem("clickCollectSelected");
                document.body.classList.remove("click-collect-active");
              }
              
              if (deliveryTimeModal) {
                const selectedTimeOption = deliveryTimeModal.options[deliveryTimeModal.selectedIndex];
                setCookie("delivery_time", selectedTimeOption.value, 365);
                setCookie("delivery_time_short", selectedTimeOption.text, 365);
              }
              
              setCookie("delivery_run", data.response.delivery_run, 365);
              setCookie("delivery_courier", data.response.courier, 365);
              setCookie("delivery_unique_window", uniqueWindow, 365);
              setCookie("delivery_type_changed", 1, 365);

              // Stamp the reservation attributes onto the cart now, so any
              // checkout entry point is correct without relying on the cart
              // page form submit.
              try {
                await syncDeliveryAttributesToCart();
                console.log('Cart attributes synced to new reservation');
              } catch (attrError) {
                console.error('Cart attribute sync failed (cart page form will re-stamp):', attrError);
              }

              // Hide delivery type prompt
                                theme.hidePromptForDeliveryType();

              // Remove delivery later cookie
              removeCookie("delivery_later");

              // Get zone distribution centre state for product filtering
              try {
                const stateParams = new URLSearchParams({
                  zone_id: _data.response.zone
                });
                
                const stateData = await fetchJSONP(
                  `${deliveryURL}get-state-filter.php?${stateParams.toString()}`,
                  "c"
                );
                
                if (stateData.status === "SUCCESS") {
                  // Set current state
                  setCookie("curr_state", stateData.state, 365);
                }
              } catch (error) {
                console.warn("State filter API blocked (likely by ad blocker), continuing...", error);
              }

              // Handle cart update or UI refresh
              // Update the initial 'reserving' step to completed (if still there - it won't be if store changed or initial reservation)
              updateDeliveryOverlayItemState('reserving', 'completed', 'Delivery slot reserved');
              
              console.log('Delivery reservation complete. doCartUpdate =', doCartUpdate);
              
              // Update header delivery details. Guarded: the reservation has already
              // succeeded, so a header rendering error must not derail the rest of the
              // flow (cart reconciliation) or trip the outer error handler.
              console.log('🔄 Updating header delivery details...');
              try {
                updateDeliveryDetailsHeader();
                updateMinutesRemaining(); // Immediately update the timer display
              } catch (headerError) {
                console.error('Header delivery details update failed:', headerError);
              }
              
              // Update cart page delivery details if function exists
              if (typeof cartDeliveryDetails === 'function') {
                console.log('🔄 Updating cart page delivery details...');
                try {
                  cartDeliveryDetails();
                } catch (cartDetailsError) {
                  console.error('Cart page delivery details update failed:', cartDetailsError);
                }
              }

                                            if (doCartUpdate) {
                // Mark appropriate overlay step as loading
                if (isInitialReservation) {
                  updateDeliveryOverlayItemState('adding-delivery', 'loading', 'Adding delivery fee to cart...');
                  console.log('===== CALLING updateCartItems() - Initial reservation, adding delivery fee =====');
                } else {
                  updateDeliveryOverlayItemState('checking-availability', 'loading', 'Checking product availability...');
                  console.log('===== CALLING updateCartItems() - Picking store changed =====');
                }
                
                // Set flag to indicate checkout needs refresh
                sessionStorage.setItem('location_changed_needs_checkout_refresh', 'true');
                console.log('🔄 Set flag: location changed, checkout needs refresh');
                
                // Wait for cart update to complete
                try {
                  await agileCart.updateCartItems();
                  // Re-read once reconciliation has released its single-flight
                  // lock so cart.js can confirm the final fee state and unlock checkout.
                  await agileCart.fetchCart();
                  console.log('✅ Cart update completed');
                  
                  // Mark overlay steps as completed
                  if (isInitialReservation) {
                    updateDeliveryOverlayItemState('adding-delivery', 'completed', 'Delivery fee added to cart');
                  } else {
                    updateDeliveryOverlayItemState('checking-availability', 'completed', 'Products updated');
                    updateDeliveryOverlayItemState('syncing-storage', 'completed', 'Location synced');
                  }
                  
                  // Close drawer after brief display
                  setTimeout(() => {
                    theme.hidePromptForDeliveryType();
                    hideDeliveryOverlay();
                  }, 1500);
                } catch (error) {
                  // The reservation itself succeeded - only the cart reconciliation
                  // failed. Keep the header/reservation UI correct regardless.
                  console.error('❌ Cart update failed:', error);
                  try {
                    updateDeliveryDetailsHeader();
                    updateMinutesRemaining();
                  } catch (headerError) {
                    console.error('Header delivery details update failed:', headerError);
                  }
                  hideDeliveryOverlay();
                }
                                            } else {
                // Day/time change only - refresh cart UI to update delivery state and checkout button
                console.log('===== NOT calling updateCartItems() - Only day/time changed =====');
                console.log('===== BUT calling fetchCart() to refresh UI and enable checkout =====');
                
                // Show simple overlay with just delivery updated
                clearDeliveryOverlayStack();
                addDeliveryOverlayUpdate('delivery-updated', 'Delivery updated', 'completed');
                showDeliveryOverlay();
                
                // CRITICAL: Update delivery details header immediately
                console.log('📍 Updating delivery details header after day/time change...');
                updateDeliveryDetailsHeader();
                updateMinutesRemaining();
                console.log('  ✓ Delivery details header updated');
                
                // Update cart page delivery details if function exists
                if (typeof cartDeliveryDetails === 'function') {
                  console.log('📍 Updating cart page delivery details...');
                  cartDeliveryDetails();
                }
                
                // Refresh cart to update delivery display and checkout button
                if (typeof agileCart !== 'undefined' && agileCart.fetchCart) {
                  agileCart.fetchCart();
                } else {
                  console.warn('AgileCart not available for cart refresh');
                  // Fallback: reload the page to ensure cart is updated
                  setTimeout(() => {
                    location.reload();
                  }, 1000);
                }
                
                // Close drawer and hide overlay after brief display
                setTimeout(() => {
                  theme.hidePromptForDeliveryType();
                  hideDeliveryOverlay();
                }, 1500);
              }
          } else {
            // The reservation itself SUCCEEDED but postcodedetails could not
            // confirm the picking store. The merchant's rule: picking_store must
            // match what the endpoint returned - NEVER complete the reservation
            // UX with stale store state. The reserved slot id encodes its store
            // ("YYYYMMDD-STORE-..."), so use that as the source of truth; if even
            // that can't be parsed, fail visibly and leave prior state untouched.
            const fallbackStore = getStoreFromUniqueWindow(uniqueWindow);
            if (!fallbackStore) {
              console.error('postcodedetails response unusable AND no store derivable from reserved slot', uniqueWindow, '- aborting without changing state:', data);
              window.__hfDeliveryReservationUpdating = false;
              if (typeof agileCart !== "undefined" && agileCart.fetchCart) agileCart.fetchCart();
              hideDeliveryOverlay();
              showDeliveryError("We couldn't confirm your delivery details. Please try again.");
              return;
            }

            console.warn(`postcodedetails response unusable after successful reservation - retrying lookup before completing with store ${fallbackStore} from reserved slot ${uniqueWindow}:`, data);

            // Retry the postcodedetails lookup before completing without
            // courier/run data. The first failure is usually transient
            // (Cloudflare 429 under load); completing without a courier
            // produces attr-mismatch orders (HF#2087182).
            let retriedRow = null;
            const retriedData = await fetchPostcodeDetailsWithRetry(postcode, deliveryDate, expressDelivery, 3);
            if (retriedData) {
              const candidateRow = retriedData.response[0];
              const candidateStore = candidateRow.picking_store ? candidateRow.picking_store.toString() : null;
              if (!clickCollect && candidateStore && candidateStore !== fallbackStore) {
                console.error(`⚠️ postcodedetails retry says postcode ${postcode} is served by store ${candidateStore} but reserved slot ${uniqueWindow} belongs to store ${fallbackStore} - ignoring retried row, keeping slot-derived store.`);
              } else {
                retriedRow = candidateRow;
                console.log('✅ postcodedetails retry succeeded - completing fallback reservation with full courier/run data:', retriedRow);
              }
            }

            const priorPickingStore =
              (window.locationManager && window.locationManager.currentLocation) ||
              localStorage.getItem('currentPickingStore') ||
              getCookie("picking_store");
            const fallbackStoreChanged = String(priorPickingStore) !== fallbackStore;

            // Sync ALL storage to the reserved slot's store before completing.
            syncPickingStoreStorage(fallbackStore);
            console.log('  Storage synced to reserved slot store:', fallbackStore);

            setCookie("postcode", postcode, 365);
            // Only take the suburb from postcode_data when it belongs to the
            // postcode being reserved - never carry a previous reservation's
            // suburb forward. If we can't tell, fall back to the retried API
            // row, then clear it rather than keep a stale value.
            if (_data.response && String(_data.response.postcode) === String(postcode)) {
              setCookie("suburb", _data.response.suburb || "", 365);
            } else if (retriedRow) {
              setCookie("suburb", retriedRow.suburb || "", 365);
            } else {
              setCookie("suburb", "", 365);
            }

            // Last-resort courier source when the retries also fail: the
            // postcode_data cookie captured when the slots were fetched. Only
            // trust it under the same postcode guard as suburb above (the
            // submit-time slotsContext check already tied that fetch to the
            // reserved slot's store). Note it holds no courier for postcodes
            // that go through the suburb dropdown, and its delivery_run was
            // fetched without a delivery_date - the background backfill below
            // still runs to heal both with date-accurate values.
            const cookieRow =
              (_data.response && String(_data.response.postcode) === String(postcode))
                ? _data.response
                : null;

            if (retriedRow) {
              // Retry recovered the full postcode row - write the courier/run
              // cookies exactly as the main path does so the cart attribute
              // sync below stamps a complete reservation.
              setCookie("delivery_run", retriedRow.delivery_run, 365);
              setCookie("delivery_courier", retriedRow.courier, 365);
            } else if (cookieRow && cookieRow.courier) {
              setCookie("delivery_courier", cookieRow.courier, 365);
              setCookie("delivery_run", cookieRow.delivery_run || "", 365);
              console.warn(`Courier/run for postcode ${postcode} (slot ${uniqueWindow}) taken from the postcode_data cookie after postcodedetails retries failed - background backfill will refresh them.`);
            } else {
              // No usable source anywhere. An ABSENT courier is detectable and
              // fixable by CS and the Flow attribute guard; a WRONG stale
              // courier from a previous reservation is worse - clear both.
              removeCookie("delivery_courier");
              removeCookie("delivery_run");
              console.warn(`No courier available from postcodedetails (3 attempts) or the postcode_data cookie for postcode ${postcode} (slot ${uniqueWindow}). Completing with slot-derived store ${fallbackStore} and NO courier - background backfill scheduled.`);
            }

            const expiryTime = new Date().getTime() + data_reservation.response.seconds_remaining * 1000;
            setCookie("delivery_expires_time", expiryTime, 365);
            if (deliveryDate) setCookie("delivery_date", deliveryDate, 365);

            const deliveryTypeModalEl = document.getElementById("sdelivery-type-modal");
            if (deliveryTypeModalEl && deliveryTypeModalEl.selectedIndex >= 0) {
              const selectedOption = deliveryTypeModalEl.options[deliveryTypeModalEl.selectedIndex];
              setCookie("delivery_type", selectedOption.value, 365);
              setCookie("delivery_type_long", selectedOption.text, 365);
            }
            if (deliveryTimeModal && deliveryTimeModal.selectedIndex >= 0) {
              const selectedTimeOption = deliveryTimeModal.options[deliveryTimeModal.selectedIndex];
              setCookie("delivery_time", selectedTimeOption.value, 365);
              setCookie("delivery_time_short", selectedTimeOption.text, 365);
            }
            setCookie("delivery_unique_window", uniqueWindow, 365);
            setCookie("delivery_type_changed", 1, 365);
            removeCookie("delivery_later");

            try {
              await syncDeliveryAttributesToCart();
              console.log('Cart attributes synced to new reservation');
            } catch (attrError) {
              console.error('Cart attribute sync failed (cart page form will re-stamp):', attrError);
            }

            // Mirror the main path's zone -> curr_state cookie when we have a
            // trustworthy zone (from the postcode_data cookie for this
            // postcode, or the retried API row).
            const fallbackZone =
              (_data.response && String(_data.response.postcode) === String(postcode) && _data.response.zone) ||
              (retriedRow && retriedRow.zone) ||
              null;
            if (fallbackZone) {
              try {
                const stateData = await fetchJSONP(
                  `${deliveryURL}get-state-filter.php?${new URLSearchParams({ zone_id: fallbackZone }).toString()}`,
                  "c"
                );
                if (stateData.status === "SUCCESS") {
                  setCookie("curr_state", stateData.state, 365);
                }
              } catch (error) {
                console.warn("State filter API blocked (likely by ad blocker), continuing...", error);
              }
            }

            if (!retriedRow) {
              // One-shot background backfill: try the lookup once more later
              // and heal the courier/run cookies + cart attributes if the
              // customer hasn't changed their reservation in the meantime.
              scheduleCourierBackfill(postcode, uniqueWindow, deliveryDate, expressDelivery, clickCollect ? null : fallbackStore);
            }

            clearDeliveryOverlayStack();
            addDeliveryOverlayUpdate('delivery-updated', 'Delivery reserved', 'completed');
            showDeliveryOverlay();

            try {
              updateDeliveryDetailsHeader();
              updateMinutesRemaining();
            } catch (headerError) {
              console.error('Header delivery details update failed:', headerError);
            }
            if (typeof cartDeliveryDetails === 'function') {
              try {
                cartDeliveryDetails();
              } catch (cartDetailsError) {
                console.error('Cart page delivery details update failed:', cartDetailsError);
              }
            }

            // Store changed: reconcile cart items/prices for the new store, same
            // as the normal path. Otherwise a UI refresh is enough.
            if (fallbackStoreChanged && typeof agileCart !== 'undefined' && agileCart.updateCartItems) {
              sessionStorage.setItem('location_changed_needs_checkout_refresh', 'true');
              try {
                await agileCart.updateCartItems();
                console.log('✅ Cart update completed (fallback path, store changed)');
              } catch (cartError) {
                console.error('❌ Cart update failed (fallback path):', cartError);
              }
            } else if (typeof agileCart !== 'undefined' && agileCart.fetchCart) {
              agileCart.fetchCart();
            }

            setTimeout(() => {
              theme.hidePromptForDeliveryType();
              hideDeliveryOverlay();
            }, 1500);
          }
        } else {
          window.__hfDeliveryReservationUpdating = false;
          if (typeof agileCart !== "undefined" && agileCart.fetchCart) agileCart.fetchCart();
          hideDeliveryOverlay();
          console.error("Reservation failed:", data_reservation);
          showDeliveryError("Unable to reserve delivery slot. Please try again.");
        }
      } catch (error) {
        window.__hfDeliveryReservationUpdating = false;
        if (typeof agileCart !== "undefined" && agileCart.fetchCart) agileCart.fetchCart();
        hideDeliveryOverlay();
        console.error("Error in delivery form submission:", error);
        showDeliveryError("Unable to process delivery reservation. Please try again.");
      }
    });
  }

  // Delivery edit button handlers
  document.querySelectorAll(".delivery-edit-btn, .change-delivery-res, .delivery-details-text").forEach(el => {
    el.addEventListener("click", function (event) {
    // Triggers are (or contain) <a href="#">; stop the default navigation so
    // opening the drawer doesn't scroll the page to the top.
    event.preventDefault();
    theme.promptForDeliveryType();
    updateDeliveryDrawer();
    });
  });

  // The "Please reserve a delivery or click and collection spot." bar shown
  // in the cart drawer when there's no (or an expired) reservation: tapping
  // it should open the delivery drawer. Delegated because the bar toggles
  // visibility rather than being re-created.
  document.addEventListener("click", function (event) {
    const reserveBar = event.target.closest(".cart-reserve__wrapper");
    if (!reserveBar) return;
    event.preventDefault();
    // Close the cart drawer first so the delivery drawer isn't stacked under it.
    document.querySelector(".js-go-cart-drawer-close")?.click();
    theme.promptForDeliveryType();
    if (typeof updateDeliveryDrawer === "function") updateDeliveryDrawer();
  });

  // Function to populate the delivery drawer with saved values
  window.updateDeliveryDrawer = function () {
    const postcode = getCookie("postcode");
    const deliveryType = getCookie("delivery_type");
    const clickAndCollect = deliveryType === "M";
    const expressDelivery = deliveryType === "EX";
    const selectedTimeSlot = getCookie("delivery_time");
    const selectedStore = getCookie("picking_store");
    
    const deliveryTypeSection = document.getElementById("delivery-type-selection-section");
    if (deliveryTypeSection) deliveryTypeSection.style.display = "block";

    const clickCollectBtn = document.getElementById("delivery-type-click-collect");
    const expressBtn = document.getElementById("delivery-type-express");
    const deliveryBtn = document.getElementById("delivery-type-delivery");
    const ccStore = document.getElementById("cc-store");
    const postcodeModal = document.getElementById("spost-code-modal");
    const deliveryTimeModal = document.getElementById("sdelivery-time-modal");
    
    // Enable postcode input
    if (postcodeModal) {
      postcodeModal.disabled = false;
      console.log('updateDeliveryDrawer: Enabled postcode input');
    }
    
    // Enable all delivery type buttons if we have a postcode
    if (postcode && postcode.length === 4) {
      if (clickCollectBtn) {
        clickCollectBtn.disabled = false;
        console.log('updateDeliveryDrawer: Enabled click & collect button');
      }
      if (expressBtn) {
        expressBtn.disabled = false;
        console.log('updateDeliveryDrawer: Enabled express button');
      }
      if (deliveryBtn) {
        deliveryBtn.disabled = false;
        console.log('updateDeliveryDrawer: Enabled delivery button');
      }
    }

    if (clickAndCollect) {
      if (clickCollectBtn) {
        clickCollectBtn.classList.add("delivery-type-select-btns-selected");
      }
      if (ccStore) ccStore.value = selectedStore;
      if (postcodeModal) postcodeModal.value = getCookie("postcode_cc_display");
      loadClickCollectStores();
    } else {
      if (expressBtn) {
        expressBtn.classList.add("delivery-type-select-btns-selected");
      }
      if (postcodeModal) postcodeModal.value = postcode;
    }

    if (expressDelivery) {
      const ccStoreRow = document.getElementById("cc-store-row");
      const expressUber = document.getElementById("delivery-express-uber");
      const noLiquorWarning = document.getElementById("delivery-express-noliquor-warning");
      
      if (ccStoreRow) ccStoreRow.style.display = "none";
      if (expressBtn) {
        expressBtn.classList.add("delivery-type-select-btns-selected");
      }
      if (expressUber) expressUber.style.display = "flex";
      if (noLiquorWarning) noLiquorWarning.style.display = "flex";
      
      if (postcode) {
        loadDeliverySlots(postcode);
      }
    }

    if (deliveryTimeModal) deliveryTimeModal.value = selectedTimeSlot;
  };

  const decideLaterBtn = document.getElementById("delivery-type-decide-later");
  if (decideLaterBtn) {
    decideLaterBtn.addEventListener("click", function () {
      console.log('User clicked "Decide Later"');
      
      // Keep location preference but clear delivery reservation
      localStorage.removeItem('activeDelivery');
      console.log('   ✓ Cleared activeDelivery, keeping location for browsing');

      // Persist the chosen picking store so browsing stays on the selected location.
      // Source it from the most reliable place, then write localStorage + cookie in
      // lockstep via the single LocationManager writer (first-loaded-scripts no longer
      // force-resets to 76 when a selection exists).
      const keepStore =
        (window.locationManager && window.locationManager.currentLocation) ||
        localStorage.getItem('selectedLocation') ||
        localStorage.getItem('currentPickingStore') ||
        getCookie("picking_store");
      if (keepStore) {
        if (window.locationManager && typeof window.locationManager.persistBrowsingLocation === 'function') {
          window.locationManager.persistBrowsingLocation(keepStore);
        } else {
          setCookie("picking_store", keepStore, 365);
          localStorage.setItem('currentPickingStore', keepStore);
          localStorage.setItem('selectedLocation', keepStore);
        }
        console.log('   ✓ Persisted browsing store for Decide Later:', keepStore);
      }
      
      // Decide Later no longer grants add-to-cart (Jul 2026): carts built
      // before a store was confirmed were the main source of mis-stamped line
      // locations. It now just closes the drawer; the next add attempt
      // re-opens it. Remove any legacy grace cookie so old sessions converge.
      removeCookie("delivery_later");
      if (getCookie("delivery_expires_time")) {
        setCookie("delivery_expires_time", 0, 365);
        checkDeliveryOptionsExpired();
      }
      // Clear the reservation attributes off the cart before reloading so they
      // cannot ride into a later checkout.
      syncDeliveryAttributesToCart()
        .catch(function (attrError) {
          console.error('Cart attribute clear failed:', attrError);
        })
        .finally(function () {
          location.reload();
        });
  });
  }

  document.querySelectorAll(".cancel-delivery-button").forEach(btn => {
    btn.addEventListener("click", function () {
      console.log('User clicked "Cancel Delivery"');
      
      // Keep location preference but clear delivery reservation
      localStorage.removeItem('activeDelivery');
      console.log('   ✓ Cleared activeDelivery, keeping location for browsing');
      
      if (getCookie("delivery_expires_time")) {
        setCookie("delivery_expires_time", 0, 365);
        checkDeliveryOptionsExpired();
    }
      // Clear the reservation attributes off the cart before reloading so a
      // cancelled reservation cannot ride into the next checkout.
      syncDeliveryAttributesToCart()
        .catch(function (attrError) {
          console.error('Cart attribute clear failed:', attrError);
        })
        .finally(function () {
          location.reload();
        });
    });
  });

  // Pre-order functionality
  const preorderToken = document.getElementById("preorder-token");
  if (preorderToken) {
    preorderToken.addEventListener("change", function () {
      const preorderInputBox = document.getElementById("delivery-preorder-token-input-box");
      const preorderInput = document.getElementById("delivery-preorder-token-input");
      const preorderInvalid = document.getElementById("delivery-preorder-invalid");
      const postcodeModal = document.getElementById("spost-code-modal");
      
      if (this.checked) {
        if (preorderInputBox) preorderInputBox.style.display = "block";
        if (preorderInput) {
          preorderInput.value = "";
          preorderInput.focus();
        }
    } else {
        if (preorderInputBox) preorderInputBox.style.display = "none";
        if (preorderInvalid) preorderInvalid.style.display = "none";
        removeCookie("delivery_preorder");
      }
      if (postcodeModal) {
        loadDeliverySlots(postcodeModal.value);
      }
    });
  }

  const preorderInput = document.getElementById("delivery-preorder-token-input");
  if (preorderInput) {
    preorderInput.addEventListener("input", async function () {
      const preorderInvalid = document.getElementById("delivery-preorder-invalid");
      if (preorderInvalid) preorderInvalid.remove();

      if (this.value.length == 6) {
        // Validate preorder number
        try {
          const response = await fetch(
            `${deliveryURL}preorder.php?token=${this.value}`,
            { headers: { 'Accept': 'application/json' } }
          ).then(r => r.json());
          
          if (response.token) {
            // Valid
            setCookie("delivery_preorder", response.token, 365);
            const deliveryBtn = document.getElementById("delivery-type-delivery");
            if (deliveryBtn) deliveryBtn.click();
          } else {
            // Invalid
            const preorderBox = document.getElementById("delivery-preorder-token-input-box");
            if (preorderBox) {
              const invalidMsg = document.createElement('div');
              invalidMsg.id = "delivery-preorder-invalid";
              invalidMsg.textContent = 'Code not valid. Enter a valid 6 digit preorder code.';
              preorderBox.prepend(invalidMsg);
            }
            removeCookie("delivery_preorder");
          }
        } catch (error) {
          console.error("Error validating preorder:", error);
        }
      }
    });
  }

  // NDIS functionality
  const ndisCheckbox = document.getElementById("ndis_checkbox");
  if (ndisCheckbox) {
    ndisCheckbox.addEventListener("change", function () {
      const ndisModal = document.getElementById("ndis-modal");
      const ndisInput = document.getElementById("ndis");
      
      if (ndisModal) {
        ndisModal.style.display = ndisModal.style.display === "none" ? "block" : "none";
      }
      
      if (!this.checked) {
        removeCookie("delivery_ndis");
        if (ndisInput) ndisInput.value = "";
        theme.promptForDeliveryType();
    } else {
        if (ndisInput) {
          ndisInput.value = getCookie("delivery_ndis") || "";
          ndisInput.focus();
        }
      }
    });
  }

  const ndisInput = document.getElementById("ndis");
  if (ndisInput) {
    ndisInput.addEventListener("input", async function () {
      const ndisModal = document.getElementById("ndis-modal");
      if (ndisModal) {
        const errors = ndisModal.querySelectorAll("td .error");
        errors.forEach(err => err.remove());
      }

      if (this.value.length == 12) {
        // Show loader
        const ndisLoader = document.getElementById("ndis_loader");
        if (ndisLoader) ndisLoader.style.display = "block";
        this.disabled = true;

        // Validate NDIS number
        try {
          const response = await fetch(
            `${deliveryURL}ndis.php?token=${this.value}`,
            { headers: { 'Accept': 'application/json' } }
          ).then(r => r.json());
          
          if (response.token) {
            // Valid
            setCookie("delivery_ndis", response.token, 365);
            theme.promptForDeliveryType();
          } else {
            // Invalid
            if (ndisModal) {
              const lastCell = ndisModal.querySelector("td:last-child");
              if (lastCell) {
                const errorDiv = document.createElement('div');
                errorDiv.className = "error";
                errorDiv.style.fontSize = "12px";
                errorDiv.textContent = "** Code not valid. Enter a valid 12 digit NDIS priority access code. **";
                lastCell.appendChild(errorDiv);
              }
            }
          }
        } catch (error) {
          console.error("Error validating NDIS:", error);
        } finally {
          if (ndisLoader) ndisLoader.style.display = "none";
          this.disabled = false;
        }
      }
    });
  }
  // End NDIS functionality

  const ccStore = document.getElementById("cc-store");
  if (ccStore) {
    ccStore.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const postcode = selectedOption ? selectedOption.dataset.zone_postcode : null;

      const elementsToHide = [
        "delivery-postcode-modal",
        "delivery-suburb-modal",
        "delivery-day-modal",
        "delivery-type-modal",
        "clickcollect-info-modal",
        "delivery-time-modal"
      ];
      
      elementsToHide.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.style.display = "none";
      });
      
      const submitBtn = document.getElementById("delivery-type-submit");
      if (submitBtn) submitBtn.disabled = true;
      
      if (this.value && postcode) {
      loadDeliverySlots(postcode);
    }
  });
  }

  const postcodeModal = document.getElementById("spost-code-modal");
  if (postcodeModal) {
    postcodeModal.addEventListener("input", function () {
      // The postcode changed: slots rendered for the previous postcode are no
      // longer valid. Clear them (and cancel any pending restore timers) so a
      // stale slot can't be reserved against the new postcode.
      invalidateSlotsContext();

      // Make sure other dropdowns/msgs are hidden and enter disabled in case re-entering postcode
      DOMHelpers.hideElements([
        "delivery-type-selection-section", "delivery-error-modal", "delivery-type-reserve",
        "delivery-suburb-modal", "delivery-day-modal", "delivery-type-modal",
        "delivery-time-modal", "clickcollect-info-modal", "delivery-preorder-token",
        "delivery-preorder-token-input-box"
      ]);
      
      const expressInfo = document.querySelectorAll(".delivery-express-info");
      expressInfo.forEach(el => el.style.display = "none");
      
      DOMHelpers.setDisabled(["delivery-type-submit", "submit-delivery-postode"], true);

      // Process post code entered - enable submit if 4 digits
      if (this.value.length == 4) {
        DOMHelpers.setDisabled(["submit-delivery-postode"], false);
      }
    });
  }

  const deliveryTypeModal = document.getElementById("sdelivery-type-modal");
  if (deliveryTypeModal) {
    deliveryTypeModal.addEventListener("change", function () {
      const submitBtn = document.getElementById("delivery-type-submit");
      const timeModal = document.getElementById("delivery-time-modal");
      const datePicker = document.getElementById("date-picker-select");
      
      if (this.value != "0") {
        selectedType = this.value;
        // Get the currently selected date from the date picker
        const currentSelectedDate = datePicker ? datePicker.value : selectedDate;
        if (currentSelectedDate && currentSelectedDate !== "Select delivery date") {
          // Show loading overlay while populating time slots
          showDeliveryOverlay();
          
          setTimeout(() => {
            updateSlotsForModal(currentSelectedDate);
            hideDeliveryOverlay();
          }, 50);
        }
    } else {
        if (timeModal) timeModal.style.display = "none";
      }
      
      if (submitBtn) submitBtn.disabled = true;
    });
  }

  const deliveryTimeModal = document.getElementById("sdelivery-time-modal");
  if (deliveryTimeModal) {
    deliveryTimeModal.addEventListener("change", function () {
      const submitBtn = document.getElementById("delivery-type-submit");
      const typeModal = document.getElementById("sdelivery-type-modal");
      
      if (this.value != "0") {
        const selectedOption = this.options[this.selectedIndex];
        const delType = selectedOption ? selectedOption.getAttribute("data-del-type") : null;
        if (typeModal && delType) typeModal.value = delType;
        if (submitBtn) submitBtn.disabled = false;
    } else {
        if (submitBtn) submitBtn.disabled = true;
    }
  });
  }
  // End delivery type selection.
}); // End DOMContentLoaded

async function showAvailableDeliveryButtons() {
  console.log('showAvailableDeliveryButtons() called');
  const postcodeModal = document.getElementById("spost-code-modal");
  
  // Enable postcode input if it's disabled
  if (postcodeModal && postcodeModal.disabled) {
    console.log('Enabling postcode input');
    postcodeModal.disabled = false;
  }
  
  const postcode = postcodeModal ? postcodeModal.value : null;
  
  console.log('Postcode value:', postcode);

  if (!postcode || postcode.length !== 4) {
    console.warn('Invalid postcode (not 4 digits):', postcode);
    return;
  }

  const savedPostcode = getCookie("postcode");
  const savedPostcodeCC = getCookie("postcode_cc_display");

  if (![savedPostcode, savedPostcodeCC].includes(postcode)) {
    // Checking different postcode to reservation - clear pre selected delivery type
    console.log('Clearing pre-selected delivery type');
    const buttons = document.querySelectorAll("#delivery-type-select-btns button");
    buttons.forEach(btn => btn.className = "");
  }

  // Check if standard delivery is available for postcode
  console.log('Checking delivery availability for postcode:', postcode);
  try {
    const data = await fetchJSONP(
      `${deliveryURL}postcodedetails.php?a=1&postcode=${postcode}&express_delivery=false`,
      "c"
    );
    
    console.log('Standard delivery response:', data);
    
    const deliveryBtn = document.getElementById("delivery-type-delivery");
    if (deliveryBtn) {
      if (data.status === "SUCCESS" && data.response && data.response[0] !== "EMPTY" && data.response[0].postcode == postcode) {
        deliveryBtn.style.display = "block";
        deliveryBtn.disabled = false;
        console.log('Showing and enabling standard delivery button');
        } else {
        deliveryBtn.style.display = "none";
        deliveryBtn.disabled = true;
      }
    }

    // Check if express delivery is available for postcode
    console.log('Checking express delivery availability...');
    const expressData = await fetchJSONP(
      `${deliveryURL}postcodedetails.php?a=1&postcode=${postcode}&express_delivery=true`,
      "c"
    );
    
    console.log('Express delivery response:', expressData);
    
    const expressBtn = document.getElementById("delivery-type-express");
    if (expressBtn) {
      if (expressData.status === "SUCCESS" && expressData.response && expressData.response[0] !== "EMPTY" && expressData.response[0].postcode == postcode) {
        console.log('Showing and enabling express button');
        expressBtn.style.display = "block";
        expressBtn.disabled = false;
              } else {
        console.log('Hiding express button');
        expressBtn.style.display = "none";
        expressBtn.disabled = true;
      }
    }
    
    // Enable click & collect button
    const clickCollectBtn = document.getElementById("delivery-type-click-collect");
    if (clickCollectBtn) {
      clickCollectBtn.disabled = false;
      console.log('Enabling click & collect button');
    }

    const selectionSection = document.getElementById("delivery-type-selection-section");
    console.log('Selection section element:', selectionSection);
    if (selectionSection) {
      console.log('Showing delivery-type-selection-section');
      selectionSection.style.display = "block";
    } else {
      console.error('delivery-type-selection-section element not found!');
    }
    
  } catch (error) {
    console.error("Error checking delivery availability:", error);
  }
}

async function loadClickCollectStores() {
  const submitBtn = document.getElementById("delivery-type-submit");
  if (submitBtn) submitBtn.disabled = true;

  // Show loading overlay
  showDeliveryOverlay();

  try {
    const response = await fetchJSONP(`${deliveryURL}clickandcollect-stores.php?dummy=1`, "c");
    
    const ccStore = document.getElementById("cc-store");
    if (ccStore && response.stores) {
      // Remove all options except the first one
      const options = Array.from(ccStore.options);
      options.slice(1).forEach(opt => opt.remove());
      
      // Add new store options
      response.stores.forEach(function (store) {
        const option = document.createElement('option');
        option.value = store.store_no;
        option.dataset.zone_postcode = store.zone_postcode;
        option.dataset.picking_store = store.picking_store;
        option.textContent = store.name;
        ccStore.appendChild(option);
      });
      
      // Restore previously selected store
      const savedStore = getCookie("delivery_cc_store");
      if (savedStore) {
        ccStore.value = savedStore;
        ccStore.dispatchEvent(new Event('change'));
      }
    }
  } catch (err) {
    console.error("Error loading click & collect stores:", err);
  } finally {
    // Hide loading overlay
    hideDeliveryOverlay();
  }
}

async function loadDeliverySlots(postcode) {
  const expressBtn = document.getElementById("delivery-type-express");
  const expressDelivery = expressBtn ? expressBtn.classList.contains("delivery-type-select-btns-selected") : false;
  
  console.log(postcode);
  console.log(expressDelivery);
  
  // New slot fetch: anything rendered for a previous postcode/type is stale.
  invalidateSlotsContext();
  const fetchEpoch = slotsFetchEpoch;
  
  // Show loading overlay
  showDeliveryOverlay();
  
  // Show loader - disable all controls
  DOMHelpers.setDisabled([
    "delivery-type-submit", "delivery-type", "ndis_checkbox", "ndis",
    "spost-code-modal", "cc-store"
  ], true);
  
  const buttons = document.querySelectorAll("#delivery-type-select-btns button");
  buttons.forEach(btn => btn.disabled = true);
  
  DOMHelpers.hideElements(["delivery-day-modal", "delivery-time-modal"]);
  
  const suburbModal = document.getElementById("delivery-suburb-modal");
  if (suburbModal) suburbModal.remove();

  try {
    const data = await fetchJSONP(
      `${deliveryURL}postcodedetails.php?a=1&postcode=${postcode}&express_delivery=${expressDelivery}`,
      "c"
    );
    
    // A newer postcode/type selection superseded this fetch while it was in
    // flight - do nothing (the newer flow owns the UI now).
    if (fetchEpoch !== slotsFetchEpoch) {
      console.log('loadDeliverySlots: superseded by a newer selection, ignoring response for', postcode);
      return;
    }
    
    console.log('loadDeliverySlots response:', data);

      if (data.status === "SUCCESS") {
      // Show delivery selection
      DOMHelpers.showElements(["delivery-type-selection-section", "delivery-type-reserve"]);

      clearReservationExpiredNotice();

      // Set postcode and picking store if not set
        if (
          data.response[0] !== "EMPTY" &&
          data.response[0].postcode == postcode
        ) {
        if (!getCookie("postcode") && !getCookie("picking_store")) {
            // Postcode ok - set postcode
          setCookie("postcode", postcode, 365);
            // Set picking store
          setCookie("picking_store", data.response[0].picking_store, 365);
          }
        }

        if (data.response == "EMPTY") {
        // No Postcode Match - show error
          errorMsg = expressDelivery ? noExpressDeliveryError : noDeliveryError;
        if (errorModal) {
          errorModal.className = "";
          errorModal.innerHTML = errorMsg;
          errorModal.style.display = "flex";
        }

        // Re-enable controls
        DOMHelpers.setDisabled([
          "delivery-type", "ndis_checkbox", "ndis",
          "spost-code-modal", "cc-store"
        ], false);
        
        const buttons = document.querySelectorAll("#delivery-type-select-btns button");
        buttons.forEach(btn => btn.disabled = false);
        
        // Hide loading overlay
        hideDeliveryOverlay();
        
        } else if (!data.response[0].suburb) {
        // Show slots available with no suburbs set for postcode
          data.response = !data.response[0].id
            ? data.response
            : data.response[0];
          return to_select_slot(data, postcode);
        } else {
        // Show slots available with suburbs set for postcode
          return to_select_suburb(data, postcode);
        }
      }
  } catch (error) {
    if (fetchEpoch !== slotsFetchEpoch) {
      console.log('loadDeliverySlots: superseded by a newer selection, ignoring error for', postcode);
      return;
    }
    console.error("Error loading delivery slots:", error);
    const errorModal = document.getElementById("delivery-error-modal");
    if (errorModal) {
      errorModal.className = "";
      errorModal.innerHTML =
        "<span class=\"delivery-error-message\"><span><b>We couldn't load delivery times.</b></span><span>Please check your connection and try again.</span></span>";
      errorModal.style.display = "flex";
    }

    DOMHelpers.setDisabled([
      "delivery-type-submit", "delivery-type", "ndis_checkbox", "ndis",
      "spost-code-modal", "cc-store"
    ], false);

    const buttons = document.querySelectorAll("#delivery-type-select-btns button");
    buttons.forEach(btn => btn.disabled = false);

    // Hide loading overlay on error
    hideDeliveryOverlay();
  }
}

function to_select_suburb(data, postcode) {
  DOMHelpers.setDisabled([
    "delivery-type", "ndis_checkbox", "ndis", "spost-code-modal", "cc-store"
  ], false);
  
  const buttons = document.querySelectorAll("#delivery-type-select-btns button");
  buttons.forEach(btn => btn.disabled = false);
  
  // Hide loading overlay
  hideDeliveryOverlay();
  
  let options = '<option value="">Select Suburb</option>';
  const s_suburb = getCookie("suburb");
  let selected = false;

  for (let k in data.response) {
    const e = data.response[k];
    const isSelected = e.suburb == s_suburb;
    if (isSelected) selected = true;
    
    const sl = isSelected ? " selected " : "";
    options +=
      `<option ${sl} value="${e.id}:${e.postcode}:${e.suburb}:${e.picking_store}:${postcode}:${e.zone}">${e.suburb}</option>`;
  }
  
  const selectHTML = `<div class="delivery-select"><select id="select-suburb-dropdown">${options}</select></div>`;
  const rowHTML = `<tr id="delivery-suburb-modal"><td><strong>Suburb</strong></td><td>${selectHTML}</td></tr>`;
  
  // Remove existing suburb modal
  const existingModal = document.getElementById("delivery-suburb-modal");
  if (existingModal) existingModal.remove();
  
  // Insert before delivery-day-modal
  const dayModal = document.getElementById("delivery-day-modal");
  if (dayModal) {
    dayModal.insertAdjacentHTML('beforebegin', rowHTML);
  }
  
  if (selected) {
    const dropdown = document.getElementById("select-suburb-dropdown");
    if (dropdown) {
      _to_select_slot(dropdown.value);
    }
  }
}

function _to_select_slot(selectedValue) {
  console.log(selectedValue);
  const v = selectedValue;

  if (!v) {
    invalidateSlotsContext();
    DOMHelpers.hideElements(["delivery-day-modal", "delivery-time-modal"]);
    hideDeliveryOverlay(); // Hide overlay when no suburb selected
    return;
  }
  
  const d = v.split(":"); //Array [ "1947", "2000", "MILLERS POINT", "73", "2000" ]
  const data = {
    response: {
      id: d[0],
      postcode: d[1],
      suburb: d[2],
      picking_store: d[3],
      zone: d[5],
    },
  };

  // Suburb changed: clear stale slots from the previous suburb so they can't
  // be reserved (also bumps the fetch epoch so pending timers abort); they are
  // repopulated when a date is (re)selected.
  invalidateSlotsContext();
  DOMHelpers.hideElements(["delivery-time-modal"]);
  
  to_select_slot(data, d[4]);
}

async function to_select_slot(data, postcode) {
  // Capture the epoch this fetch belongs to; if the user changes postcode /
  // type / suburb while we're in flight, the epoch advances and everything
  // below must abort rather than render or restore stale slots.
  const fetchEpoch = slotsFetchEpoch;
  const expressBtn = document.getElementById("delivery-type-express");
  const expressDelivery = expressBtn ? expressBtn.classList.contains("delivery-type-select-btns-selected") : false;
  const postcodeType = expressDelivery ? "Express" : "Normal";

  if (data.response.postcode == postcode) {
    setCookie("postcode_data", JSON.stringify(data), 365);
    // Record which postcode/suburb/store the slot list being fetched belongs
    // to; the reserve submit handler refuses any slot that doesn't match.
    slotsContext = {
      postcode: String(postcode),
      suburb: data.response.suburb || "",
      store: String(data.response.picking_store),
    };

    const params = {
      cart_id: getCookie("cart") || '',
      postcode: postcode,
      suburb: data.response.suburb || "",
      postcode_type: postcodeType,
      store_number: data.response.picking_store
    };
    
    if (getCookie("delivery_ndis")) params.ndis = "1";
    if (getCookie("delivery_preorder")) params.preorder = "1";

    try {
      const response = await fetchJSONP(`${deliveryURL}get-dates.php`, params);
      if (fetchEpoch !== slotsFetchEpoch) {
        console.log('to_select_slot: superseded by a newer selection, ignoring slots for', postcode);
        return;
      }
      slots_modal = response;
        displaySlotsForModal(slots_modal);
      
      // Only restore the saved reservation into the dropdowns when the slot
      // list on screen is for the SAME postcode as that reservation. Restoring
      // it against a new postcode re-selected the old store's slot and
      // re-enabled the reserve button - booking the wrong store.
      if (getCookie("delivery_expires_time") && getCookie("postcode") === String(postcode)) {
        // Show selected delivery options if reservation already set.
        // displaySlotsForModal() fills the date options inside a 50ms timeout,
        // so restoring synchronously silently failed: the date stayed on its
        // placeholder while the time select (whose options are NOT rebuilt on
        // suburb change) restored against stale options and re-enabled the
        // submit button. Restore after the options exist, and only cascade to
        // type/time once the date actually applied.
        setTimeout(() => {
          // Abort if the user changed postcode/type/suburb since this restore
          // was scheduled - the slot list it targets is gone.
          if (fetchEpoch !== slotsFetchEpoch) return;
          const datePicker = document.getElementById("date-picker-select");
          const savedDate = getCookie("delivery_date") || '';
          
          if (datePicker && savedDate) {
            datePicker.value = savedDate;
          }
          
          if (datePicker && savedDate && datePicker.value === savedDate) {
            datePicker.dispatchEvent(new Event('change'));
            
            // The date change handler repopulates the type/time dropdowns
            // asynchronously (~350ms); restore their values after that.
            setTimeout(() => {
              if (fetchEpoch !== slotsFetchEpoch) return;
              const deliveryTypeModal = document.getElementById("sdelivery-type-modal");
              const deliveryTimeModal = document.getElementById("sdelivery-time-modal");
              const savedType = getCookie("delivery_type") || '';
              const savedTime = getCookie("delivery_time") || '';
              
              if (deliveryTypeModal && savedType) {
                deliveryTypeModal.value = savedType;
              }
              if (deliveryTimeModal && savedTime) {
                deliveryTimeModal.value = savedTime;
                if (deliveryTimeModal.value === savedTime) {
                  deliveryTimeModal.dispatchEvent(new Event('change'));
                }
              }
            }, 600);
          }
        }, 150);
      }
      
      const dayModal = document.getElementById("delivery-day-modal");
      if (dayModal) dayModal.style.display = "flex";
    } finally {
      // Only touch the controls/overlay if a newer selection hasn't taken
      // over the UI (it manages its own enable/disable and overlay).
      if (fetchEpoch === slotsFetchEpoch) {
        // Re-enable controls
        DOMHelpers.setDisabled([
          "delivery-type", "ndis_checkbox", "ndis", "spost-code-modal", "cc-store"
        ], false);
        
        const buttons = document.querySelectorAll("#delivery-type-select-btns button");
        buttons.forEach(btn => btn.disabled = false);
        
        // Hide loading overlay
        hideDeliveryOverlay();
      }
    }
  }
}

document.addEventListener("change", function (event) {
  if (event.target && event.target.id === "select-suburb-dropdown") {
    const selectedValue = event.target.value;
    console.log(selectedValue);
    
    // Show loading overlay - this can be slow
    showDeliveryOverlay();
    
    // Call _to_select_slot which will hide the overlay when done loading
    _to_select_slot(selectedValue);
  }
});

const selectElement = document.getElementById("select-suburb-dropdown");
if (selectElement) {
  const currentValue = selectElement.value;
  _to_select_slot(currentValue);
}

function displaySlotsForModal(slots_modal) {
  availableDatesForModal = []; // Clear array before adding dates
  const datePicker = document.getElementById("date-picker-select");
  
  if (!datePicker) return;
  
  // Show loading state
  datePicker.innerHTML = "<option>Loading dates...</option>";
  datePicker.disabled = true;
  
  // Clear and enable after a brief moment to show loading
  setTimeout(() => {
    datePicker.innerHTML = "";
    datePicker.disabled = false;

  if (slots_modal.dates != null) {
    // Add dates to array
    availableDatesForModal = Object.keys(slots_modal.dates).map(key => slots_modal.dates[key]);
    
    // Sort dates in array
    availableDatesForModal.sort(function (a, b) {
      let date1 = a.split("-").join(""),
        date2 = b.split("-").join("");
      return date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
    });
    
    // Add dates to select
    datePicker.appendChild(new Option("Select delivery date"));
    availableDatesForModal.forEach(function (delDate) {
      let [year, month, day] = delDate.split("-");
      datePicker.appendChild(
        new Option(
          new Date(year, month - 1, day).toLocaleDateString("en-AU", {
            weekday: "long",
            day: "numeric",
            month: "long",
          }),
          delDate
        )
      );
    });
    
    // Add change event listener
    datePicker.addEventListener("change", function () {
      selectedDate = this.value;
      if (selectedDate != "Select delivery date") {        
        // Show loading overlay while populating dropdowns
        showDeliveryOverlay();
        
        // Wait for CSS transition (400ms) + processing time
        setTimeout(() => {
        updateTypesForModal(selectedDate);
        updateSlotsForModal(selectedDate);
          
          // Show day modal (delivery type dropdown)
          const dayModal = document.getElementById("delivery-day-modal");
          if (dayModal) dayModal.style.display = "flex";
          
          // Don't show time modal yet - let updateSlotsForModal handle that
          // after checking if slots are actually available
          
          DOMHelpers.setDisabled(["delivery-type-submit"], true);
          
          // Keep overlay visible for minimum 500ms total, then hide
          setTimeout(() => {
            hideDeliveryOverlay();
          }, 200);
        }, 300);
      } else {
        DOMHelpers.hideElements(["delivery-time-modal", "delivery-day-modal"]);
        DOMHelpers.setDisabled(["delivery-type-submit"], true);
      }
    });
  } else {
    datePicker.appendChild(new Option("No dates available"));
    datePicker.disabled = true;
  }
  }, 50); // End of setTimeout for loading state
}

function updateTypesForModal(selectedDate) {
  if (!slots_modal || !slots_modal["slots"] || slots_modal["slots"][selectedDate] == undefined) {
    console.warn("No delivery slots available for date:", selectedDate);
    // Don't populate dropdowns if no slots available
    const typeModal = document.getElementById("sdelivery-type-modal");
    if (typeModal) {
      typeModal.innerHTML = '<option>No slots available</option>';
      typeModal.disabled = true;
    }
    return false;
  }

  const typeModal = document.getElementById("sdelivery-type-modal");
  if (!typeModal) return;
  
  typeModal.innerHTML = "";
  let optionHtml = '<option value="0">Select delivery type</option>';

  Object.keys(slots_modal["slots"][selectedDate]).forEach(function (i) {
    const el = slots_modal["slots"][selectedDate][i];
    optionHtml += `<option value="${i}">${el.description}</option>`;
  });

  typeModal.innerHTML = optionHtml;
}

function updateSlotsForModal(selectedDate) {
  const timeModal = document.getElementById("sdelivery-time-modal");
  if (!timeModal) return;
  
  // Check if slots exist for this date
  if (!slots_modal || !slots_modal["slots"] || !slots_modal["slots"][selectedDate]) {
    console.warn("No time slots available for date:", selectedDate);
    timeModal.innerHTML = '<option>No times available</option>';
    timeModal.disabled = true;
    
    // Hide the time modal container
    const deliveryTimeModal = document.getElementById("delivery-time-modal");
    if (deliveryTimeModal) deliveryTimeModal.style.display = "none";
    
    return;
  }
  
  // Show loading state
  timeModal.innerHTML = '<option>Loading times...</option>';
  timeModal.disabled = true;
  
  // Populate slots after a brief moment
  setTimeout(() => {
  timeModal.innerHTML = "";
  let optionHtml = '<option value="0">Select delivery time</option>';
  
  Object.keys(slots_modal["slots"][selectedDate]).forEach(function (x) {
    const v = slots_modal["slots"][selectedDate][x];
    selectedType = x;
    
    if (v["time"]) {
      Object.keys(v["time"]).forEach(function (i) {
        const el = v["time"][i];
        
        optionHtml += `<option value="${el.value}" data-del-type="${selectedType}" data-slot-id="${el.id}" data-expiry="${el.e}">${el.description}</option>`;
      });
    }
  });
  
  timeModal.innerHTML = optionHtml;
  
  // Sort options by slot ID
  const options = Array.from(timeModal.querySelectorAll("option:not([value='0'])"));
  options.sort(function (a, b) {
    const aSlotId = a.getAttribute("data-slot-id") || '';
    const bSlotId = b.getAttribute("data-slot-id") || '';
    
    const aPart = aSlotId.substring(
      aSlotId.split("-", 4).join("-").length + 1,
      aSlotId.length
    );
    const bPart = bSlotId.substring(
      bSlotId.split("-", 4).join("-").length + 1,
      bSlotId.length
    );
    
    return aPart < bPart ? -1 : aPart > bPart ? 1 : 0;
  });
  
  // Append sorted options
  options.forEach(opt => timeModal.appendChild(opt));
  
  // Re-enable the dropdown
  timeModal.disabled = false;
  
  const deliveryTimeModal = document.getElementById("delivery-time-modal");
  if (deliveryTimeModal) deliveryTimeModal.style.display = "flex";
  }, 50); // End of setTimeout for loading state
}

function clearReservationExpiredNotice() {
  const errorModal = document.getElementById("delivery-error-modal");
  if (!errorModal) return;
  errorModal.classList.remove("reservation-expired");
  errorModal.style.display = "none";
  errorModal.innerHTML = "";
}

//Update header with the currently selected delivery details.
function updateDeliveryDetailsHeader() {
  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const deliveryDateStr = getCookie("delivery_date");
  const deliveryDate = new Date(deliveryDateStr);
  let deliveryDetailsHTML,
    deliveryDay,
    deliveryTimeShort = getCookie("delivery_time_short") || "";
  let pickingStore = getCookie("picking_store");
  // Local, always-defined store name: the old implicit-global version threw a
  // ReferenceError when the picking_store cookie or storeMatrix entry was missing,
  // which silently killed the whole header update.
  let storeName = "Store not found";

  if (getCookie("delivery_expires_time") != null) {
    //Check if delivery reservation expired.
    if (checkDeliveryOptionsExpired()) {
      if (window.theme && typeof window.theme.promptForDeliveryType === "function") {
        window.theme.promptForDeliveryType();
      }
      return; //Exit
    }

    clearReservationExpiredNotice();

    //Update delivery details box.
    const deliveryTypeSuffixIndex = deliveryTimeShort.indexOf("(");
    deliveryTimeShort = (
      deliveryTypeSuffixIndex >= 0
        ? deliveryTimeShort.substring(0, deliveryTypeSuffixIndex)
        : deliveryTimeShort
    )
      .trim()
      .replace(/:00 /g, "")
      .toLowerCase();

    console.log(deliveryTimeShort);

    deliveryDay = weekday[deliveryDate.getDay()].substring(0, 3);

    if (pickingStore) {
      const storeId = parseInt(pickingStore, 10);
      storeName = storeMatrix[0][storeId] || storeName;
    }

    //deliveryTimer =
    deliveryDetailsHTML = `<a href="#">
         <div class="delivery-flex-organiser">
          <div class="delivery-store">
            <label class="delivery-to-label">Picking store</label>
            <span class="">${storeName}</span>
          </div>
          <div class="delivery-divider first-divider"></div>
           <div class="delivery-to">
              <label class="delivery-to-label">Delivering to</label>
              <span class="postcode-text"></span>
           </div>
           <div class="delivery-divider"></div>
           <div class="delivery-date-time">
              <div class="minutes-remaining hide-minutes">${getDeliveryMinutesRemaining()}</div>
              <label class="">Delivery slot</label>
              <span class="delivery_date">${deliveryDay} ${deliveryTimeShort}</span>
           </div>
           <div class="delivery-edit-btn">
             <svg class="icon-edit" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m18 84.2c1 0 1.2-.1 2.1-.3l18-3.6c1.9-.5 3.8-1.4 5.3-2.9l43.6-43.6c6.7-6.7 6.7-18.2 0-24.9l-3.7-3.9c-6.7-6.7-18.3-6.7-25 0l-43.6 43.7c-1.4 1.4-2.4 3.4-2.9 5.3l-3.8 18.2c-.5 3.4.5 6.7 2.9 9.1 1.9 1.9 4.7 2.9 7.1 2.9zm3.4-28.3 43.6-43.7c2.9-2.9 8.2-2.9 11 0l3.8 3.8c3.4 3.4 3.4 8.2 0 11.5l-43.5 43.7-18.5 3.1z"/><path d="m86.6 90.4h-73.8c-2.9 0-4.8 1.9-4.8 4.8s2.4 4.8 4.8 4.8h73.4c2.9 0 5.3-1.9 5.3-4.8-.1-2.9-2.5-4.8-4.9-4.8z"/></g></svg>
           </div>
         </div>
      </a>`;

    const headerDialog = document.querySelector(".header__delivery--dialog");
    if (headerDialog) headerDialog.classList.add("delivery_active");
    
    const detailsText = document.querySelector(".delivery-details-text");
    if (detailsText) {
      detailsText.innerHTML = deliveryDetailsHTML;
      
      // Populate suburb after HTML is inserted
      const postcodeTextEl = detailsText.querySelector(".postcode-text");
      const suburb = getCookie("suburb");
      if (postcodeTextEl && suburb) {
        postcodeTextEl.textContent = suburb;
      }
    }

    //Update minutes.
    //const minutesRemaining = document.querySelector(".minutes_remaining");
    //if (minutesRemaining) minutesRemaining.innerHTML = timeConvert(getDeliveryMinutesRemaining());

    //Show delivery details box.
    showDeliveryDetailsBox();

    // Function to convert minutes into a countdown format (hh:mm)
    function convertToCountdown(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0"
      )}`;
    }

    // Function to update the countdown every minute until it reaches zero
    function startCountdown() {
      let remainingMinutes = getDeliveryMinutesRemaining();

      function updateCountdown() {
        if (remainingMinutes > 0) {
          const countdown = convertToCountdown(remainingMinutes);
          console.log(countdown); // Display the countdown (you can update it in your UI)
          if (document.body.classList.contains("template-cart")) {
            cartTimer.innerHTML = countdown + " left";
            cartTimer.style.display = "block";
          }
          remainingMinutes--;
          //setTimeout(updateCountdown, 60000); // Call this function again after 1 minute (60,000 ms)
        } else {
          console.log("Countdown reached zero!"); // Or update your UI to indicate the countdown has reached zero
          //Clear delivery cookies.
          clearDeliveryCookies();

          //Clear reservation end timer;
          clearInterval(resEndIntHandle);
          //Hide delivery details box.
          hideDeliveryDetailsBox();
        }
      }

      // Initial call to start the countdown
      //updateCountdown();
    }

    //startCountdown();

    //Bind to resize event.
    window.addEventListener("resize", function () {
      if (getCookie("delivery_expires_time")) {
        showDeliveryDetailsBox();
      }
    });

    //Update delivery link.
    // Scope to the details box: ".delivery-to-label" also matches the
    // "Picking store" label, so an unscoped querySelector relabelled the wrong
    // block and left "Delivering to" visible for Click & Collect.
    const detailsBox = document.querySelector(".delivery-details-text");
    const storeLabel = detailsBox?.querySelector(".delivery-store .delivery-to-label");
    const storeNameSpan = detailsBox?.querySelector(".delivery-store span");
    const deliveryToBlock = detailsBox?.querySelector(".delivery-to");
    const firstDivider = detailsBox?.querySelector(".delivery-divider.first-divider");
    const slotLabel = detailsBox?.querySelector(".delivery-date-time label");
    const postcodeText = detailsBox?.querySelector(".postcode-text");

    if (getCookie("delivery_type") == "M") {
      // Click & Collect: there is no delivery, so hide the "Delivering to"
      // block and present the store block as the collection point.
      if (storeLabel) storeLabel.innerHTML = "Click & collect";
      if (slotLabel) slotLabel.innerHTML = "Pickup slot";
      const ccName = (getCookie("delivery_cc_name") || '')
        .replace("Junction", "")
        .replace("(", "")
        .replace(")", "");
      if (storeNameSpan && ccName) storeNameSpan.innerHTML = ccName;
      if (deliveryToBlock) deliveryToBlock.style.display = "none";
      if (firstDivider) firstDivider.style.display = "none";
    } else {
      if (postcodeText) postcodeText.innerHTML = getCookie("suburb") || '';
    }

    //Update reservation expiry timer every 30 seconds.
    if (resEndIntHandle) clearInterval(resEndIntHandle);
    resEndIntHandle = setInterval(function () {
      if (checkDeliveryOptionsExpired()) {
        if (window.theme && typeof window.theme.promptForDeliveryType === "function") {
          window.theme.promptForDeliveryType();
        }
      }
    }, 30000);
  }
}

updateDeliveryDetailsHeader();

//Check if delivery options have expired, if so clear cookies and make expire msg visible on postcode/delivery popup.
function checkDeliveryOptionsExpired() {
  if (getDeliveryMinutesRemaining() <= 0) {
    console.log('Delivery reservation expired');
    
    // Clear delivery reservation but KEEP user's location preference
    localStorage.removeItem('activeDelivery'); // Clear delivery flag
    // Keep selectedLocation and currentPickingStore so user stays at their preferred location
    
    console.log('   Cleared activeDelivery flag');
    console.log('   Keeping location preference:', localStorage.getItem('selectedLocation') || localStorage.getItem('currentPickingStore'));
    console.log('   User can continue browsing, but must re-reserve delivery to checkout');
    
    // Clear delivery cookies before refreshing cart state so long-lived tabs do
    // not keep using a stale in-memory add-to-cart/checkout gate.
    clearDeliveryCookies();
    document.dispatchEvent(new CustomEvent("deliveryReservationExpired", {
      detail: {
        selectedLocation: localStorage.getItem('selectedLocation') || localStorage.getItem('currentPickingStore')
      }
    }));

    const deliveryExpired = true;
    agileCart.fetchCart(deliveryExpired);

    //Clear reservation end timer;
    if (resEndIntHandle) {
      clearInterval(resEndIntHandle);
      resEndIntHandle = null;
    }
    if (document.body.classList.contains("template-cart")) {
      document.querySelector(".delivery-updating").textContent =
        "Please reserve a delivery slot or pickup store.";
    }
    //Hide delivery details box.
    hideDeliveryDetailsBox();
    //Show expired delivery options message on popup.
    errorMsg = `<span class="delivery-error-message"><span><b>Your delivery reservation has expired.</b></span><span>Please choose a new time to continue.</span></span>`;
    const errorModal = document.getElementById("delivery-error-modal");
    if (errorModal) {
      errorModal.classList.add("reservation-expired");
      errorModal.innerHTML = errorMsg;
      errorModal.style.display = "flex";
    }

    //If on cart page - show expired message in place of delivery details.
    if (document.body.classList.contains("template-cart")) {
      DOMHelpers.showElements(["reserve_delivery_msg"]);
      DOMHelpers.hideElements(["delivery_cart_table"]);
    }
    return true;
  }
  return false;
}

// Get number of minutes remaining for delivery reservation.
function getDeliveryMinutesRemaining() {
  const currTime = new Date().getTime();
  const expiresTime = getCookie("delivery_expires_time");
  const minutesRemaining = expiresTime != null
    ? parseInt((expiresTime - currTime) / 60000)
      : 0;
  return minutesRemaining;
}

// Function to update the minutes remaining
function updateMinutesRemaining() {
  var minutesRemaining = getDeliveryMinutesRemaining();
  var minutesRemainingElement = document.querySelector(".minutes-remaining");

  if (minutesRemainingElement) {
    if (minutesRemaining > 0) {
      minutesRemainingElement.innerHTML = `<svg enable-background="new 0 0 371.263 371.263" height="512" viewBox="0 0 371.263 371.263" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m305.402 234.794v-70.54c0-52.396-33.533-98.085-79.702-115.151.539-2.695.838-5.449.838-8.204.001-22.575-18.323-40.899-40.898-40.899s-40.899 18.324-40.899 40.899c0 2.695.299 5.389.778 7.964-15.868 5.629-30.539 14.551-43.054 26.647-23.593 22.755-36.587 53.354-36.587 86.169v73.115c0 2.575-2.096 4.731-4.731 4.731-22.096 0-40.959 16.647-42.995 37.845-1.138 11.797 2.755 23.533 10.719 32.276 7.904 8.683 19.222 13.713 31.018 13.713h72.217c2.994 26.887 25.869 47.905 53.534 47.905s50.54-21.018 53.534-47.905h72.217c11.797 0 23.114-5.03 31.018-13.713 7.904-8.743 11.797-20.479 10.719-32.276-2.036-21.198-20.958-37.845-42.995-37.845-2.635-.001-4.731-2.097-4.731-4.731zm-119.762-210.842c9.341 0 16.946 7.605 16.946 16.946 0 .778-.12 1.497-.24 2.275-4.072-.599-8.204-1.018-12.336-1.138-7.126-.24-14.132.24-21.078 1.198-.12-.778-.24-1.497-.24-2.275.002-9.401 7.607-17.006 16.948-17.006zm0 323.358c-14.431 0-26.527-10.3-29.342-23.952h58.683c-2.813 13.653-14.909 23.952-29.341 23.952zm143.655-67.665c.479 5.15-1.138 10.12-4.551 13.892-3.533 3.773-8.204 5.868-13.353 5.868h-251.501c-5.15 0-9.82-2.096-13.294-5.868-3.473-3.772-5.09-8.743-4.611-13.892.838-9.042 9.282-16.168 19.162-16.168 15.809 0 28.683-12.874 28.683-28.683v-73.115c0-26.228 10.419-50.719 29.282-68.923 18.024-17.425 41.498-26.887 66.528-26.887 1.198 0 2.335 0 3.533.06 50.839 1.796 92.277 45.929 92.277 98.325v70.54c0 15.809 12.874 28.683 28.683 28.683 9.88 0 18.264 7.126 19.162 16.168z"/></g></g></svg> ${minutesRemaining}mins remaining`;
      if (minutesRemaining < 15) {
        minutesRemainingElement.classList.remove("hide-minutes");
      }
    } else {
      minutesRemainingElement.textContent = "Time is up!";
      clearInterval(countdownInterval); // Stop the interval when time is up
    }
  }
}

var countdownInterval = setInterval(updateMinutesRemaining, 60000);
// Initial call to set the countdown immediately on page load
updateMinutesRemaining();

//Show either mobile or non mobile delivery details box.
function showDeliveryDetailsBox() {
  DOMHelpers.showElements(["delivery-details-box"]);
  
  const deliveryWrapper = document.querySelectorAll(".delivery-wrapper");
  const deliveryDetails = document.querySelectorAll(".delivery-details");
  
  deliveryWrapper.forEach(el => el.style.display = "none");
  deliveryDetails.forEach(el => el.style.display = "flex");
}

//Hide delivery details box.
function hideDeliveryDetailsBox() {
  const detailsText = document.querySelector(".delivery-details-text");
  if (detailsText) {
    detailsText.innerHTML = `<svg class="icon icon-location" version="1.1" id="svg192" xml:space="preserve" width="682.66669" height="682.66669" viewBox="0 0 682.66669 682.66669" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><defs id="defs196"><clipPath clipPathUnits="userSpaceOnUse" id="clipPath206"><path d="M 0,512 H 512 V 0 H 0 Z" id="path204"></path></clipPath></defs><g id="g198" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g id="g200"><g id="g202" clip-path="url(#clipPath206)"><g id="g208" transform="translate(324.9316,350.6797)"><path d="m 0,0 c 0,-38.07 -30.861,-68.932 -68.932,-68.932 -38.07,0 -68.931,30.862 -68.931,68.932 0,38.07 30.861,68.932 68.931,68.932 C -30.861,68.932 0,38.07 0,0 Z" style="fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path210"></path></g><g id="g212" transform="translate(371.8301,440.165)"><path d="m 0,0 c -27.55,35.6 -70.81,56.87 -115.83,56.87 -45.02,0 -88.28,-21.27 -115.83,-56.87 -31.07,-40.16 -36.63,-88.55 -20.3,-135.84 15.7,-45.46 49.04,-83.37 76.3,-122.44 19.5,-27.95 39,-55.9 58.5,-83.86 0.44,-0.63 0.89,-1.27 1.33,-1.9 0.44,0.63 0.89,1.27 1.33,1.9 19.5,27.96 39,55.91 58.5,83.86 27.26,39.07 60.6,76.98 76.3,122.44 C 36.63,-88.55 31.07,-40.16 0,0 Z" style="fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path214"></path></g><g id="g216" transform="translate(164.25,126.8052)"><path d="m 0,0 -42.65,-26.94 134.4,-84.9 134.4,84.9 L 183.5,0" style="fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path218"></path></g></g></g></g></svg> Set my location`;
  }
  
  DOMHelpers.hideElements(["delivery-details-box", "mobile-delivery-details"]);
  
  const deliveryWrapper = document.querySelectorAll(".delivery-wrapper");
  const deliveryDetails = document.querySelectorAll(".delivery-details");
  
  deliveryDetails.forEach(el => el.style.display = "none");
  deliveryWrapper.forEach(el => el.style.display = "flex");
}

// The reserved slot id ("unique_window") is store-specific:
// "YYYYMMDD-STORE-TYPE-ZONE-START-END" (e.g. "20260705-87-EX-287-1000-1100").
// Returns the store number segment, or null if it cannot be parsed.
function getStoreFromUniqueWindow(uniqueWindow) {
  const parts = String(uniqueWindow || '').split('-');
  return parts.length >= 2 && /^\d+$/.test(parts[1]) ? parts[1] : null;
}

// Write the picking store to every storage location in lockstep (cookie,
// localStorage, LocationManager). Single helper so a reservation can never
// leave the stores half-synced.
function syncPickingStoreStorage(store) {
  const storeStr = String(store);
  setCookie("picking_store", storeStr, 365);
  localStorage.setItem('currentPickingStore', storeStr);
  if (window.locationManager) {
    window.locationManager.setLocation(storeStr);
  } else {
    localStorage.setItem('selectedLocation', storeStr);
  }
}

// When a late heal moves the picking store (stale cookie vs reserved window /
// CC store), attributes alone are not enough — line prices and availability
// are store-specific. Kick the same cart revalidation path used on store
// switch / checkout guard. Debounced per target store so attribute sync +
// cart form stamp in the same tick only run one pass.
function scheduleCartReconcileAfterStoreHeal(previousStore, truthStore) {
  const fromStore = previousStore == null ? '' : String(previousStore);
  const toStore = truthStore == null ? '' : String(truthStore);
  if (!toStore || fromStore === toStore) return;
  if (window.__hfStoreHealReconcileScheduled === toStore) return;
  window.__hfStoreHealReconcileScheduled = toStore;

  console.warn(
    `Store heal ${fromStore || 'empty'} → ${toStore}: scheduling cart product revalidation (price/availability)`
  );

  setTimeout(function () {
    try {
      if (typeof agileCart !== 'undefined' && agileCart && typeof agileCart.updateCartItems === 'function') {
        sessionStorage.setItem('location_changed_needs_checkout_refresh', 'true');
        agileCart.updateCartItems({ revalidate: true }).catch(function (err) {
          console.warn('Store-heal cart revalidation failed (will retry via checkout guard):', err);
          window.__hfStoreHealReconcileScheduled = null;
        });
      } else {
        window.__hfStoreHealReconcileScheduled = null;
      }
    } catch (e) {
      window.__hfStoreHealReconcileScheduled = null;
      console.warn('Store-heal cart revalidation error:', e);
    }
  }, 0);
}

// Retryable postcodedetails lookup. The endpoint can be 429/challenged by
// Cloudflare under load (same failure mode syncDeliveryAttributesToCart
// guards against); a JSONP request surfaces that as a script error or
// timeout, and a challenge page as an unusable body - all retryable.
// Resolves with the validated response (response[0] usable and matching the
// requested postcode) or null after all attempts fail. 3-attempt backoff
// mirrors syncDeliveryAttributesToCart.
async function fetchPostcodeDetailsWithRetry(postcode, deliveryDate, expressDelivery, attempts = 3) {
  for (let attempt = 0; attempt < attempts; attempt++) {
    if (attempt > 0) {
      await new Promise(function (resolve) { setTimeout(resolve, attempt === 1 ? 600 : 1500); });
    }
    try {
      const params = new URLSearchParams({
        postcode: postcode,
        delivery_date: deliveryDate || '',
        express_delivery: expressDelivery
      });
      const result = await fetchJSONP(
        `${deliveryURL}postcodedetails.php?a=1&${params.toString()}`,
        "c",
        'GET',
        6000
      );
      const usable =
        result &&
        result.status === "SUCCESS" &&
        result.response &&
        result.response[0] &&
        result.response[0] !== "EMPTY" &&
        result.response[0].postcode == postcode;
      if (usable) return result;
      console.warn(`postcodedetails retry got unusable response (attempt ${attempt + 1}/${attempts})${attempt < attempts - 1 ? " - retrying" : ""}:`, result);
    } catch (error) {
      console.warn(`postcodedetails retry failed (attempt ${attempt + 1}/${attempts})${attempt < attempts - 1 ? " - retrying" : ""}:`, error);
    }
  }
  return null;
}

// Belt-and-braces for the fallback completion path: when the reservation
// completed without courier/run data (postcodedetails unusable even after
// retries - order HF#2087182), take one more shot in the background ~25s
// later and heal the cookies + cart attributes so most sessions reach
// checkout with a courier stamped. Guarded against the customer having
// changed reservation in the interim (unique_window/postcode must still
// match) and against a store mismatch with the reserved slot.
function scheduleCourierBackfill(postcode, uniqueWindow, deliveryDate, expressDelivery, slotStore) {
  setTimeout(async function () {
    try {
      if (getCookie("delivery_unique_window") !== uniqueWindow || getCookie("postcode") !== String(postcode)) {
        console.log('Courier backfill skipped - reservation changed since fallback completion.');
        return;
      }
      const retried = await fetchPostcodeDetailsWithRetry(postcode, deliveryDate, expressDelivery, 1);
      if (!retried) {
        console.warn('Courier backfill: postcodedetails still unusable - leaving courier unset for CS/Flow guard to catch.');
        return;
      }
      const row = retried.response[0];
      const rowStore = row.picking_store ? row.picking_store.toString() : null;
      if (slotStore && rowStore && rowStore !== slotStore) {
        console.error(`⚠️ Courier backfill: postcodedetails says store ${rowStore} but reserved slot ${uniqueWindow} belongs to store ${slotStore} - not backfilling.`);
        return;
      }
      // Re-check after the async lookup: the customer may have re-reserved
      // while the request was in flight.
      if (getCookie("delivery_unique_window") !== uniqueWindow) {
        console.log('Courier backfill skipped - reservation changed during lookup.');
        return;
      }
      setCookie("delivery_run", row.delivery_run, 365);
      setCookie("delivery_courier", row.courier, 365);
      await syncDeliveryAttributesToCart();
      console.log('✅ Courier backfill complete - cart attributes healed with courier', row.courier, 'run', row.delivery_run);
      if (typeof agileCart !== "undefined" && agileCart.fetchCart) {
        agileCart.fetchCart();
      }
    } catch (error) {
      console.error('Courier backfill failed:', error);
    }
  }, 25000);
}

// The order attributes stamped onto the cart for a delivery reservation,
// sourced from the same cookies the cart page hidden-input form uses. With no
// valid reservation every key is an empty string, which deletes the attribute
// on /cart/update.js.
function getDeliveryAttributesFromCookies() {
  const expiresTime = getCookie("delivery_expires_time");
  const hasReservation = expiresTime && parseInt(expiresTime, 10) > new Date().getTime();
  const cookieMap = {
    delivery_date: "delivery_date",
    delivery_run: "delivery_run",
    picking_store: "picking_store",
    courier: "delivery_courier",
    unique_window: "delivery_unique_window",
    delivery_type: "delivery_type",
    delivery_cc_store: "delivery_cc_store",
    postcode: "postcode",
    // The suburb cookie is rewritten from the reserved slot's context before
    // this sync runs; without this key a re-reservation left the cart's
    // delivery_suburb attribute stuck on the previous reservation's suburb.
    delivery_suburb: "suburb",
    local_delivery_request: "delivery_time",
  };
  const attributes = {};
  Object.keys(cookieMap).forEach(function (key) {
    attributes[key] = hasReservation ? (getCookie(cookieMap[key]) || "") : "";
  });

  // Final safety check: the reserved slot id encodes its store and IS the
  // reservation's ground truth. If the picking_store cookie disagrees (e.g. a
  // stale URL location filter stomped storage after the reservation - order
  // HF#2086176 / HF#2092143), stamp the SLOT's store and heal storage in
  // lockstep. Applies to delivery AND click & collect — never send checkout a
  // picking_store that contradicts the reserved window / CC store.
  if (hasReservation) {
    const slotStore = getStoreFromUniqueWindow(attributes.unique_window);
    const ccStore = attributes.delivery_cc_store || "";
    // Slot wins when parseable; C&C falls back to delivery_cc_store.
    const truthStore = slotStore || (attributes.delivery_type === "M" ? ccStore : "") || "";

    if (truthStore && attributes.picking_store !== truthStore) {
      const previousStore = attributes.picking_store;
      console.error(
        `⚠️ picking_store cookie (${previousStore || "empty"}) disagrees with reserved store ${truthStore}` +
        ` (window: ${attributes.unique_window || "n/a"}, cc: ${ccStore || "n/a"}) - using the reserved store and re-healing storage.`
      );
      attributes.picking_store = truthStore;
      syncPickingStoreStorage(truthStore);
      // Prices + availability are per-store — reconcile cart lines too.
      scheduleCartReconcileAfterStoreHeal(previousStore, truthStore);
    }

    // Keep C&C store aligned with the slot when both are present.
    if (slotStore && ccStore && ccStore !== slotStore) {
      console.error(
        `⚠️ delivery_cc_store (${ccStore}) disagrees with reserved slot ${attributes.unique_window} (store ${slotStore}) - aligning CC store to the slot.`
      );
      attributes.delivery_cc_store = slotStore;
      setCookie("delivery_cc_store", slotStore, 365);
    }
  }
  return attributes;
}

// Keep the cart's order attributes matching the current reservation state so
// every checkout entry point sees correct values, not just the cart page form
// (which only stamps them when it is submitted).
// 3-attempt backoff (mirrors writeReconcileStamp in cart.js): /cart/update.js
// can 409 against a concurrent cart mutation, or be 429/challenged by
// Cloudflare under load - a single failed sync used to leave the cart's
// attributes stale until the cart page form happened to re-stamp them.
async function syncDeliveryAttributesToCart() {
  let lastError = null;
  for (let attempt = 0; attempt < 3; attempt++) {
    if (attempt > 0) {
      await new Promise(function (resolve) { setTimeout(resolve, attempt === 1 ? 1000 : 3000); });
    }
    let response;
    try {
      // Cookies are re-read on every attempt so a retry always sends the
      // freshest reservation state (including any picking_store heal).
      response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: getDeliveryAttributesFromCookies() }),
      });
    } catch (networkError) {
      lastError = networkError;
      console.warn(`Cart attribute sync network error (attempt ${attempt + 1}/3)${attempt < 2 ? " - retrying" : ""}:`, networkError);
      continue;
    }
    if (response.ok) {
      return response.json();
    }
    lastError = new Error("Cart attribute sync failed: " + response.status);
    const retryable = response.status === 409 || response.status === 429 || response.status >= 500;
    if (!retryable) {
      throw lastError;
    }
    console.warn(`Cart attribute sync got ${response.status} (attempt ${attempt + 1}/3)${attempt < 2 ? " - retrying" : ""}`);
  }
  throw lastError;
}

function clearDeliveryCookies() {
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const name = cookie.split('=')[0].trim();
    if (
      /^delivery_/.test(name) &&
      ![
        "delivery_type",
        "delivery_ndis",
        "delivery_cc_store",
        "delivery_later",
      ].includes(name)
    ) {
      removeCookie(name);
    }
  });
}

// Loading overlay functions
function showDeliveryLoading() {
  let overlay = document.getElementById('delivery-loading-overlay');
  
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'delivery-loading-overlay';
    overlay.innerHTML = `
      <div class="delivery-loading-content">
        <div class="delivery-spinner"></div>
        <p>Processing your delivery reservation...</p>
      </div>
    `;
    document.body.appendChild(overlay);
    
    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      #delivery-loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      #delivery-loading-overlay.show {
        opacity: 1;
      }
      .delivery-loading-content {
        background: white;
        padding: 40px;
        border-radius: 8px;
        text-align: center;
        max-width: 400px;
      }
      .delivery-spinner {
        width: 50px;
        height: 50px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: delivery-spin 1s linear infinite;
        margin: 0 auto 20px;
      }
      @keyframes delivery-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .delivery-loading-content p {
        margin: 0;
        font-size: 16px;
        color: #333;
      }
    `;
    document.head.appendChild(style);
  }
  
  setTimeout(() => overlay.classList.add('show'), 10);
}

function hideDeliveryLoading() {
  const overlay = document.getElementById('delivery-loading-overlay');
  if (overlay) {
    overlay.classList.remove('show');
    setTimeout(() => overlay.remove(), 300);
  }
}

// Success/Error notification functions
function showDeliverySuccess(message) {
  showDeliveryNotification(message, 'success');
}

function showDeliveryError(message) {
  showDeliveryNotification(message, 'error');
}

function showDeliveryNotification(message, type = 'success') {
  let container = document.getElementById('delivery-notification-container');
  
  if (!container) {
    container = document.createElement('div');
    container.id = 'delivery-notification-container';
    document.body.appendChild(container);
    
    // Add styles
    const style = document.createElement('style');
    style.textContent = `
      #delivery-notification-container {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10001;
      }
      .delivery-notification {
        background: white;
        padding: 20px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        margin-bottom: 10px;
        min-width: 300px;
        display: flex;
        align-items: center;
        gap: 12px;
        animation: slideInRight 0.3s ease;
        border-left: 4px solid;
      }
      .delivery-notification.success {
        border-left-color: #28a745;
      }
      .delivery-notification.error {
        border-left-color: #dc3545;
      }
      .delivery-notification-icon {
        font-size: 24px;
      }
      .delivery-notification.success .delivery-notification-icon {
        color: #28a745;
      }
      .delivery-notification.error .delivery-notification-icon {
        color: #dc3545;
      }
      .delivery-notification-message {
        flex: 1;
        margin: 0;
        font-size: 14px;
        color: #333;
      }
      @keyframes slideInRight {
        from {
          transform: translateX(400px);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  const notification = document.createElement('div');
  notification.className = `delivery-notification ${type}`;
  notification.innerHTML = `
    <span class="delivery-notification-icon">${type === 'success' ? '✓' : '✕'}</span>
    <p class="delivery-notification-message">${message}</p>
  `;
  
  container.appendChild(notification);
  
  // Auto-remove after 4 seconds
  setTimeout(() => {
    notification.style.animation = 'slideInRight 0.3s ease reverse';
    setTimeout(() => notification.remove(), 300);
  }, 4000);
}

// ============================================================
// Custom dropdown panel for delivery drawer selects (desktop only).
//
// The native <select> stays in the DOM as the source of truth: we only
// suppress the OS popup and render our own list. The panel is rebuilt from
// the select's CURRENT options on every open, so it doesn't matter that the
// drawer re-creates/re-populates these selects dynamically (suburb, day,
// time, C&C store). Selecting an option sets selectedIndex on the native
// select and dispatches a real bubbling `change` event, so every existing
// handler (direct-bound and document-delegated) keeps working untouched.
// Mobile keeps the native wheel/sheet picker.
// ============================================================
(function () {
  const SHEET_MODE = window.matchMedia("(max-width: 749px)");
  let openPanel = null;
  let openSelect = null;
  let openBackdrop = null;

  function closePanel() {
    if (openPanel) openPanel.remove();
    if (openBackdrop) openBackdrop.remove();
    if (openSelect) openSelect.setAttribute("aria-expanded", "false");
    openPanel = null;
    openSelect = null;
    openBackdrop = null;
  }

  function updateScrolledToEnd(panel) {
    const atEnd = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 4;
    panel.classList.toggle("is-scrolled-to-end", atEnd);
  }

  function buildPanel(select) {
    const panel = document.createElement("ul");
    panel.className = "delivery-select__panel";
    panel.setAttribute("role", "listbox");
    panel.addEventListener("scroll", function () {
      updateScrolledToEnd(panel);
    }, { passive: true });

    Array.from(select.options).forEach((option, index) => {
      const item = document.createElement("li");
      item.className = "delivery-select__option";
      item.setAttribute("role", "option");
      if (option.disabled) {
        item.classList.add("is-disabled");
        item.setAttribute("aria-disabled", "true");
      }
      if (index === select.selectedIndex) {
        item.classList.add("is-selected");
        item.setAttribute("aria-selected", "true");
      }
      item.textContent = option.textContent;

      if (!option.disabled) {
        item.addEventListener("mousedown", function (event) {
          // mousedown (not click) so we beat the outside-close handler.
          event.preventDefault();
          event.stopPropagation();
          const changed = select.selectedIndex !== index;
          select.selectedIndex = index;
          closePanel();
          if (changed) {
            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      panel.appendChild(item);
    });

    return panel;
  }

  function openFor(select) {
    openSelect = select;
    openPanel = buildPanel(select);
    select.setAttribute("aria-expanded", "true");

    if (SHEET_MODE.matches) {
      // Bottom sheet: rendered on <body> so the drawer's overflow/stacking
      // can't clip it, with a backdrop to catch outside taps.
      openBackdrop = document.createElement("div");
      openBackdrop.className = "delivery-select__backdrop";
      openPanel.classList.add("delivery-select__panel--sheet");
      document.body.appendChild(openBackdrop);
      document.body.appendChild(openPanel);
    } else {
      select.parentElement.appendChild(openPanel);
      select.focus({ preventScroll: true });
    }

    const selected = openPanel.querySelector(".is-selected");
    if (selected) selected.scrollIntoView({ block: "nearest" });

    // Runs after insertion (and any scrollIntoView) so clientHeight/
    // scrollHeight reflect the real, laid-out panel.
    updateScrolledToEnd(openPanel);
  }

  document.addEventListener("mousedown", function (event) {
    const select = event.target.closest(".delivery-drawer__wrapper .delivery-select select");

    if (select && !select.disabled) {
      // Suppress the OS picker; we render our own list.
      event.preventDefault();
      const reopeningSame = openSelect === select;
      closePanel();
      if (reopeningSame) return; // second tap toggles closed
      openFor(select);
      return;
    }

    // Any other press closes an open panel (option presses are handled
    // above with stopPropagation).
    if (openPanel && !openPanel.contains(event.target)) closePanel();
  });

  // iOS Safari opens its picker from the tap's click/focus, which
  // preventDefault on the synthetic mousedown doesn't always reach. Cancel
  // the tap at touchend instead (a completed tap, so scrolling is unaffected)
  // and drive the sheet from here; preventDefault also suppresses the
  // synthetic mousedown/click so the handler above won't double-fire.
  document.addEventListener("touchend", function (event) {
    const select = event.target.closest(".delivery-drawer__wrapper .delivery-select select");
    if (!select || select.disabled) return;
    event.preventDefault();
    const reopeningSame = openSelect === select;
    closePanel();
    if (reopeningSame) return;
    openFor(select);
  }, { passive: false });

  function moveHighlight(step) {
    const items = Array.from(openPanel.querySelectorAll(".delivery-select__option:not(.is-disabled)"));
    if (!items.length) return;
    const current = openPanel.querySelector(".delivery-select__option.is-highlighted") ||
      openPanel.querySelector(".delivery-select__option.is-selected");
    let index = items.indexOf(current);
    index = Math.min(Math.max(index + step, 0), items.length - 1);
    items.forEach(item => item.classList.remove("is-highlighted"));
    items[index].classList.add("is-highlighted");
    items[index].scrollIntoView({ block: "nearest" });
  }

  // Keyboard support while a panel is open: arrows move the highlight,
  // Enter/Space commit, Escape/Tab close. Everything else is inert (the
  // native select must not act on keys while our panel is showing).
  document.addEventListener("keydown", function (event) {
    // A focused native select opens the OS picker on Space/Enter/Arrow keys
    // straight from the keyboard, bypassing our mousedown/touchend
    // interception. Catch those keys here too so a focused-but-closed
    // select opens our custom panel instead.
    if (!openPanel) {
      const select = event.target.closest(".delivery-drawer__wrapper .delivery-select select");
      if (select && !select.disabled) {
        if (event.key === " " || event.key === "Enter" || event.key === "ArrowDown" || event.key === "ArrowUp") {
          event.preventDefault();
          openFor(select);
          return;
        }
      }
      return;
    }

    if (event.key === "Escape" || event.key === "Tab") {
      closePanel();
      return;
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      moveHighlight(event.key === "ArrowDown" ? 1 : -1);
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const highlighted = openPanel.querySelector(".delivery-select__option.is-highlighted");
      if (highlighted) {
        // Reuse the pointer path so selection behaviour stays identical.
        highlighted.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true }));
      } else {
        closePanel();
      }
      return;
    }

    // Swallow other keys (typeahead etc.) so the focused native select
    // can't change value behind the open panel.
    if (event.target === openSelect) event.preventDefault();
  });

  // The drawer hides rows / swaps content while a panel could be open.
  document.addEventListener("change", function (event) {
    if (openSelect && event.target === openSelect) closePanel();
  });
})();
